/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import React from 'react';
import Icon from '../Icon.js';
import { i as iconPropTypes } from '../iconPropTypes-4cbeb95d.js';
import '@core/icon-helpers';
import 'prop-types';

var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _circle, _path29, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _circle41, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _circle42, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _circle43, _path89, _circle44, _path90, _circle45, _path91, _path92, _circle46, _path93, _path94, _circle47, _path95, _circle48, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _circle49, _circle50, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _circle51, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _circle52, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _rect, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _switch;
const ArrowShiftDown = /*#__PURE__*/React.forwardRef(function ArrowShiftDown({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23,6V16h5a1,1,0,0,1,.707,1.707l-12,12a.9994.9994,0,0,1-1.414,0l-12-12A1,1,0,0,1,4,16H9V6a2.0023,2.0023,0,0,1,2-2H21A2.0027,2.0027,0,0,1,23,6ZM16,27.5859,25.5859,18H21V6H11V18H6.4141Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ArrowShiftDown.propTypes = iconPropTypes;
}
const ArrowsHorizontal = /*#__PURE__*/React.forwardRef(function ArrowsHorizontal({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.41 26.59L7.83 23 28 23 28 21 7.83 21 11.41 17.41 10 16 4 22 10 28 11.41 26.59z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 10L22 4 20.59 5.41 24.17 9 4 9 4 11 24.17 11 20.59 14.59 22 16 28 10z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ArrowsHorizontal.propTypes = iconPropTypes;
}
const ArrowsVertical = /*#__PURE__*/React.forwardRef(function ArrowsVertical({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6 20.6L24 24.2 24 4 22 4 22 24.2 18.4 20.6 17 22 23 28 29 22z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 4L3 10 4.4 11.4 8 7.8 8 28 10 28 10 7.8 13.6 11.4 15 10z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ArrowsVertical.propTypes = iconPropTypes;
}
const Asleep = /*#__PURE__*/React.forwardRef(function Asleep({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
      d: "M7.2,2.3c-1,4.4,1.7,8.7,6.1,9.8c0.1,0,0.1,0,0.2,0c-1.1,1.2-2.7,1.8-4.3,1.8c-0.1,0-0.2,0-0.2,0C5.6,13.8,3,11,3.2,7.7 C3.2,5.3,4.8,3.1,7.2,2.3 M8,1L8,1C4.1,1.6,1.5,5.3,2.1,9.1c0.6,3.3,3.4,5.8,6.8,5.9c0.1,0,0.2,0,0.3,0c2.3,0,4.4-1.1,5.8-3 c0.2-0.2,0.1-0.6-0.1-0.7c-0.1-0.1-0.2-0.1-0.3-0.1c-3.9-0.3-6.7-3.8-6.4-7.6C8.3,3,8.4,2.4,8.6,1.8c0.1-0.3,0-0.6-0.3-0.7 C8.1,1,8.1,1,8,1z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5025,5.4136A15.0755,15.0755,0,0,0,25.096,23.6082a11.1134,11.1134,0,0,1-7.9749,3.3893c-.1385,0-.2782.0051-.4178,0A11.0944,11.0944,0,0,1,13.5025,5.4136M14.98,3a1.0024,1.0024,0,0,0-.1746.0156A13.0959,13.0959,0,0,0,16.63,28.9973c.1641.006.3282,0,.4909,0a13.0724,13.0724,0,0,0,10.702-5.5556,1.0094,1.0094,0,0,0-.7833-1.5644A13.08,13.08,0,0,1,15.8892,4.38,1.0149,1.0149,0,0,0,14.98,3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Asleep.propTypes = iconPropTypes;
}
const AsleepFilled = /*#__PURE__*/React.forwardRef(function AsleepFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.98,3a1.0024,1.0024,0,0,0-.1746.0156A13.0959,13.0959,0,0,0,16.63,28.9973c.1641.006.3282,0,.4909,0a13.0724,13.0724,0,0,0,10.702-5.5556,1.0094,1.0094,0,0,0-.7833-1.5644A13.08,13.08,0,0,1,15.8892,4.38,1.0149,1.0149,0,0,0,14.98,3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AsleepFilled.propTypes = iconPropTypes;
}
const Assembly = /*#__PURE__*/React.forwardRef(function Assembly({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16,25.4l-8-4.7v-9.4l8-4.7l8,4.7v9.4L16,25.4z M10,19.6l6,3.5l6-3.5v-7.1l-6-3.5l-6,3.5V19.6z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M27,8.2L17,2.3C16.7,2.1,16.4,2,16,2s-0.7,0.1-1,0.3L5,8.2c-0.6,0.4-1,1-1,1.7v12.2c0,0.7,0.4,1.4,1,1.7l10,5.9 c0.3,0.2,0.7,0.3,1,0.3s0.7-0.1,1-0.3l10-5.9c0.6-0.4,1-1,1-1.7V9.9C28,9.2,27.6,8.5,27,8.2z M26,22.1L16,28L6,22.1V9.9L16,4l10,5.9 V22.1z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Assembly.propTypes = iconPropTypes;
}
const AssemblyCluster = /*#__PURE__*/React.forwardRef(function AssemblyCluster({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3,4.9l-4.5-2.7C16.5,2.1,16.3,2,16,2s-0.5,0.1-0.7,0.2l-4.5,2.7C10.3,5.2,10,5.7,10,6.2v5.6c0,0.5,0.3,1,0.7,1.3 l4.5,2.7c0.2,0.1,0.5,0.2,0.7,0.2s0.5-0.1,0.7-0.2l4.5-2.7c0.4-0.3,0.7-0.7,0.7-1.3V6.2C22,5.7,21.7,5.2,21.3,4.9z M20,11.5l-4,2.4 l-4-2.4v-5l4-2.4l4,2.4V11.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3,18.9l-4.5-2.7C24.5,16.1,24.3,16,24,16s-0.5,0.1-0.7,0.2l-4.5,2.7c-0.4,0.3-0.7,0.7-0.7,1.3v5.6c0,0.5,0.3,1,0.7,1.3 l4.5,2.7c0.2,0.1,0.5,0.2,0.7,0.2s0.5-0.1,0.7-0.2l4.5-2.7c0.4-0.3,0.7-0.7,0.7-1.3v-5.6C30,19.7,29.7,19.2,29.3,18.9z M28,25.5 l-4,2.4l-4-2.4v-5l4-2.4l4,2.4V25.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3,18.9l-4.5-2.7C8.5,16.1,8.3,16,8,16s-0.5,0.1-0.7,0.2l-4.5,2.7C2.3,19.2,2,19.7,2,20.2v5.6c0,0.5,0.3,1,0.7,1.3 l4.5,2.7C7.5,29.9,7.7,30,8,30s0.5-0.1,0.7-0.2l4.5-2.7c0.4-0.3,0.7-0.7,0.7-1.3v-5.6C14,19.7,13.7,19.2,13.3,18.9z M12,25.5l-4,2.4 l-4-2.4v-5l4-2.4l4,2.4V25.5z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AssemblyCluster.propTypes = iconPropTypes;
}
const AssemblyReference = /*#__PURE__*/React.forwardRef(function AssemblyReference({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7 5.1H12.2V7.1H8.7z",
    transform: "rotate(-30.582 10.48 6.101)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6,12H4V9.9c0-0.7,0.4-1.4,1-1.7l1.5-0.9l1,1.7L6,9.9V12z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M4 14H6V18H4z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5,24.7L5,23.8c-0.6-0.4-1-1-1-1.7V20h2v2.1L7.5,23L6.5,24.7z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 24.1H11.5V27.6H9.5z",
    transform: "rotate(-59.421 10.48 25.9)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5,27.1L16,28l-1.5-0.9l-1,1.7l1.5,0.9c0.3,0.2,0.7,0.3,1,0.3c0.4,0,0.7-0.1,1-0.3l1.5-0.9L17.5,27.1z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8 24.9H23.3V26.9H19.8z",
    transform: "rotate(-30.582 21.502 25.912)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2,24.9l-1-1.7l1.8-1V20h2v2.1c0,0.7-0.4,1.4-1,1.7L25.2,24.9z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M26 14H28V18H26z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12h-2V9.9l-1.8-1l1-1.7l1.8,1c0.6,0.4,1,1,1,1.7V12z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 4.3H22.5V7.8H20.5z",
    transform: "rotate(-59.421 21.501 6.089)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5,4.9L16,4l-1.5,0.9l-1-1.7L15,2.3C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l1.5,0.9L17.5,4.9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AssemblyReference.propTypes = iconPropTypes;
}
const Asset = /*#__PURE__*/React.forwardRef(function Asset({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M12,24a4,4,0,1,1,4-4A4.0042,4.0042,0,0,1,12,24Zm0-6a2,2,0,1,0,2,2A2.0023,2.0023,0,0,0,12,18Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M30,6a4.0042,4.0042,0,0,0-4-4,3.949,3.949,0,0,0-1.8537.4768L7.7571,10.9579A9.9921,9.9921,0,1,0,21.066,24.1929l8.49-16.3994A3.9491,3.9491,0,0,0,30,6ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM22.0194,5.8083C22.0163,5.8732,22,5.9343,22,6a4.0042,4.0042,0,0,0,4,4c.0645,0,.1245-.016.1882-.019l-4.3318,8.3617a10.0168,10.0168,0,0,0-8.2158-8.1962ZM12,28a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,12,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Asset.propTypes = iconPropTypes;
}
const AssetConfirm = /*#__PURE__*/React.forwardRef(function AssetConfirm({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M21 27.18L18.41 24.59 17 26 21 30 28 23 26.59 21.59 21 27.18z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M12,24a4,4,0,1,1,4-4A4.0042,4.0042,0,0,1,12,24Zm0-6a2,2,0,1,0,2,2A2.0023,2.0023,0,0,0,12,18Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M26,2a3.86,3.86,0,0,0-1.85.48L7.76,10.96A9.99,9.99,0,0,0,12,30a9.3445,9.3445,0,0,0,2-.21V27.75A8.2289,8.2289,0,0,1,12,28a8,8,0,1,1,8-8,8.2656,8.2656,0,0,1-.06,1h2.78L29.56,7.79A3.9727,3.9727,0,0,0,26,2ZM21.86,18.34a10.0187,10.0187,0,0,0-8.22-8.19l8.38-4.34c0,.06-.02.12-.02.19a3.9989,3.9989,0,0,0,4,4c.06,0,.12-.02.19-.02ZM26,8a2,2,0,1,1,2-2A2.0058,2.0058,0,0,1,26,8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AssetConfirm.propTypes = iconPropTypes;
}
const AssetDigitalTwin = /*#__PURE__*/React.forwardRef(function AssetDigitalTwin({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "7",
    r: "2"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M12,23a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,12,23Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,12,19Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "14",
    r: "1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "17.909",
    cy: "5.705",
    r: "1"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "9.787",
    cy: "9.907",
    r: "1"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "12.495",
    cy: "8.506",
    r: "1"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "15.201",
    cy: "7.105",
    r: "1"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "4.696",
    cy: "13.187",
    r: "1"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "2.133",
    cy: "21.631",
    r: "1"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "3.079",
    cy: "24.516",
    r: "1"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: "4.848",
    cy: "26.982",
    r: "1"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: "7.272",
    cy: "28.81",
    r: "1"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: "2.098",
    cy: "18.596",
    r: "1"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: "2.979",
    cy: "15.691",
    r: "1"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: "7.081",
    cy: "11.308",
    r: "1"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: "20.616",
    cy: "4.304",
    r: "1"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: "23.323",
    cy: "2.903",
    r: "1"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: "28.988",
    cy: "8.89",
    r: "1"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: "27.587",
    cy: "11.596",
    r: "1"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: "26.186",
    cy: "14.303",
    r: "1"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: "24.784",
    cy: "17.01",
    r: "1"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: "23.383",
    cy: "19.717",
    r: "1"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: "21.982",
    cy: "22.424",
    r: "1"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: "18.637",
    cy: "27.464",
    r: "1"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: "16.092",
    cy: "29.122",
    r: "1"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: "13.166",
    cy: "29.932",
    r: "1"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: "10.133",
    cy: "29.825",
    r: "1"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: "20.572",
    cy: "25.125",
    r: "1"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: "28.893",
    cy: "3.24",
    r: "1"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: "26.188",
    cy: "2.004",
    r: "1"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "26",
    r: "1"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: "6",
    cy: "20",
    r: "1"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "20",
    r: "1"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: "6.804",
    cy: "17",
    r: "1"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: "17.196",
    cy: "23",
    r: "1"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "25.196",
    r: "1"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: "15",
    cy: "14.804",
    r: "1"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "14.804",
    r: "1"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: "15",
    cy: "25.196",
    r: "1"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: "6.804",
    cy: "23",
    r: "1"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: "17.196",
    cy: "17",
    r: "1"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: "30",
    cy: "6.026",
    r: "1"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AssetDigitalTwin.propTypes = iconPropTypes;
}
const AssetView = /*#__PURE__*/React.forwardRef(function AssetView({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "24",
    r: "2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M12,24a4,4,0,1,1,2.981-6.667l-1.49,1.334A2,2,0,1,0,12,22Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M26,2a3.86,3.86,0,0,0-1.85.48L7.76,10.96A9.99,9.99,0,0,0,12,30V28a8,8,0,1,1,5.63-13.68l1.4-1.4a10.0059,10.0059,0,0,0-5.39-2.77l8.38-4.34c0,.06-.02.12-.02.19a3.9989,3.9989,0,0,0,4,4c.06,0,.12-.02.19-.02L23.07,16h2.24l4.25-8.21A3.9727,3.9727,0,0,0,26,2Zm0,6a2,2,0,1,1,2-2A2.0058,2.0058,0,0,1,26,8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AssetView.propTypes = iconPropTypes;
}
const AssetMovement = /*#__PURE__*/React.forwardRef(function AssetMovement({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M12,13h14.2l-2.6,2.6,1.4,1.4,5-5-5-5-1.4,1.4,2.6,2.6h-14.2s0,2,0,2ZM28,19h-13.2l2.6-2.6-1.4-1.4-5,5,5,5,1.4-1.4-2.6-2.6h13.2v-2ZM22,7v-3c0-1.1-.9-2-2-2H4c-1.1,0-2,.9-2,2v24c0,1.1.9,2,2,2h16c1.1,0,2-.9,2-2v-3h-2v3H4V4h16v3h2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AssetMovement.propTypes = iconPropTypes;
}
const AssignmentActionUsage = /*#__PURE__*/React.forwardRef(function AssignmentActionUsage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M21,2h-10C6,2,2,6,2,11v10c0,5,4,9,9,9h10c5,0,9-4,9-9v-10c0-5-4-9-9-9ZM28,21c0,3.9-3.1,7-7,7h-10c-3.9,0-7-3.1-7-7v-10c0-3.9,3.1-7,7-7h10c3.9,0,7,3.1,7,7v10ZM9.5,19c.8284,0,1.5.6716,1.5,1.5s-.6716,1.5-1.5,1.5-1.5-.6716-1.5-1.5.6716-1.5,1.5-1.5ZM9.5,10c.8284,0,1.5.6716,1.5,1.5s-.6716,1.5-1.5,1.5-1.5-.6716-1.5-1.5.6716-1.5,1.5-1.5ZM14,12h10v2h-10v-2ZM14,18h10v2h-10v-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AssignmentActionUsage.propTypes = iconPropTypes;
}
const Asterisk = /*#__PURE__*/React.forwardRef(function Asterisk({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M28.316 13.949L27.684 12.051 17 15.612 17 4 15 4 15 15.612 4.316 12.051 3.684 13.949 14.368 17.51 7.2 27.066 8.8 28.267 16 18.667 23.2 28.267 24.8 27.066 17.632 17.51 28.316 13.949z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Asterisk.propTypes = iconPropTypes;
}
const Async = /*#__PURE__*/React.forwardRef(function Async({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m23.2156,4h2.7844v-2h-7v6h2v-2.9038c4.2354,1.9346,7,6.1523,7,10.9038,0,6.6167-5.3833,12-12,12v2c7.7197,0,14-6.2803,14-14,0-5.0088-2.6318-9.5122-6.7844-12Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m16,20c-.8284,0-1.5.6716-1.5,1.5s.6716,1.5,1.5,1.5,1.5-.6716,1.5-1.5-.6716-1.5-1.5-1.5h0Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9H17V18H15z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m16,4v-2C8.2803,2,2,8.2803,2,16c0,4.9766,2.6074,9.4937,6.7842,12h-2.7842v2h7v-6h-2v2.9033c-4.2634-1.9556-7-6.186-7-10.9033,0-6.6167,5.3833-12,12-12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Async.propTypes = iconPropTypes;
}
const At = /*#__PURE__*/React.forwardRef(function At({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M16,3A12.92,12.92,0,0,0,3,16v1A13,13,0,0,0,16,30h7V28H16A11,11,0,0,1,5,17V16A10.94,10.94,0,0,1,16,5,10.64,10.64,0,0,1,27,16c0,3.59-1.4,5-3.66,5C21.76,21,21,19.71,21,18V10H19v1.94A3.84,3.84,0,0,0,15.5,10,5.48,5.48,0,0,0,10,15.44v2.12A5.48,5.48,0,0,0,15.5,23a4.28,4.28,0,0,0,4-2.46A4.35,4.35,0,0,0,23.41,23C26.48,23,29,21,29,16A12.72,12.72,0,0,0,16,3Zm3,14.56a3.5,3.5,0,0,1-7,0V15.44a3.5,3.5,0,0,1,7,0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  At.propTypes = iconPropTypes;
}
const Attachment = /*#__PURE__*/React.forwardRef(function Attachment({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1,18.9L13.1,3.9c-2.5-2.6-6.6-2.6-9.2-0.1S1.3,10.5,3.9,13c0,0,0.1,0.1,0.1,0.1L6.8,16l1.4-1.4l-2.9-2.9 C3.6,10,3.6,7.1,5.3,5.4s4.6-1.8,6.3-0.1c0,0,0,0,0.1,0.1l14.9,14.9c1.8,1.7,1.8,4.6,0.1,6.3c-1.7,1.8-4.6,1.8-6.3,0.1 c0,0,0,0-0.1-0.1l-7.4-7.4c-1-1-0.9-2.6,0-3.5c1-0.9,2.5-0.9,3.5,0l4.1,4.1l1.4-1.4c0,0-4.2-4.2-4.2-4.2c-1.8-1.7-4.6-1.6-6.3,0.2 c-1.6,1.7-1.6,4.4,0,6.2l7.5,7.5c2.5,2.6,6.6,2.6,9.2,0.1S30.7,21.5,28.1,18.9C28.1,19,28.1,18.9,28.1,18.9L28.1,18.9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Attachment.propTypes = iconPropTypes;
}
const AttributeDefinition = /*#__PURE__*/React.forwardRef(function AttributeDefinition({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4c-1.1046,0-2,.8954-2,2v24c0,1.1046.8954,2,2,2h24c1.1046,0,2-.8954,2-2V4c0-1.1046-.8954-2-2-2ZM28,28H4V4h24v24ZM16.3496,22.0015l-.9629-3.0605h-4.2646l-.9458,3.0605h-2.3042l4.0239-12.0029h2.8203l3.9893,12.0029h-2.356ZM13.2891,12.062h-.0864l-1.5303,4.9355h3.1641l-1.5474-4.9355ZM19.9585,19.7129v-4.959h-1.3242v-1.7539h.688c.6538,0,.8599-.311.8599-.9302v-1.5054h1.9775v2.4355h1.8403v1.7539h-1.8403v5.4922h1.7026v1.7539h-1.582c-1.5132,0-2.3218-.8252-2.3218-2.2871Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AttributeDefinition.propTypes = iconPropTypes;
}
const AttributeUsage = /*#__PURE__*/React.forwardRef(function AttributeUsage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M21,2h-10C6.0374,2,2,6.0374,2,11v10c0,4.9626,4.0374,9,9,9h10c4.9626,0,9-4.0374,9-9v-10c0-4.9626-4.0374-9-9-9ZM28,21c0,3.8599-3.1401,7-7,7h-10c-3.8599,0-7-3.1401-7-7v-10c0-3.8599,3.1401-7,7-7h10c3.8599,0,7,3.1401,7,7v10ZM15.4775,22.0015l-.9629-3.0605h-4.2646l-.9458,3.0605h-2.3042l4.0239-12.0029h2.8203l3.9893,12.0029h-2.356ZM12.417,12.062h-.0864l-1.5303,4.9355h3.1641l-1.5474-4.9355ZM19.0864,19.7129v-4.959h-1.3242v-1.7539h.688c.6538,0,.8599-.311.8599-.9302v-1.5054h1.9775v2.4355h1.8403v1.7539h-1.8403v5.4922h1.7026v1.7539h-1.582c-1.5132,0-2.3218-.8252-2.3218-2.2871Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AttributeUsage.propTypes = iconPropTypes;
}
const AudioConsole = /*#__PURE__*/React.forwardRef(function AudioConsole({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M28,14H27V2H25V14H24a2.0019,2.0019,0,0,0-2,2v2a2.0023,2.0023,0,0,0,2,2h1V30h2V20h1a2.0027,2.0027,0,0,0,2-2V16A2.0023,2.0023,0,0,0,28,14Zm0,4H24V16h4Z",
    transform: "translate(0 .005)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M18,6H17V2H15V6H14a2.0019,2.0019,0,0,0-2,2v2a2.0019,2.0019,0,0,0,2,2h1V30h2V12h1a2.002,2.002,0,0,0,2-2V8A2.002,2.002,0,0,0,18,6Zm0,4H14V8h4Z",
    transform: "translate(0 .005)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M8,20H7V2H5V20H4a2.0023,2.0023,0,0,0-2,2v2a2.0023,2.0023,0,0,0,2,2H5v4H7V26H8a2.0023,2.0023,0,0,0,2-2V22A2.0023,2.0023,0,0,0,8,20Zm0,4H4V22H8Z",
    transform: "translate(0 .005)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AudioConsole.propTypes = iconPropTypes;
}
const AugmentedReality = /*#__PURE__*/React.forwardRef(function AugmentedReality({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4473,9.1055l-6-3a1.0008,1.0008,0,0,0-.8946,0l-6,3A1,1,0,0,0,14,10v7a1,1,0,0,0,.5527.8945l6,3a1.001,1.001,0,0,0,.8946,0l6-3A1,1,0,0,0,28,17V10A1,1,0,0,0,27.4473,9.1055ZM21,8.1182,24.7637,10,21,11.8818,17.2363,10Zm-5,3.5,4,2v4.7636l-4-2Zm6,6.7636V13.6182l4-2v4.7636Z"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: "13.5",
    cy: "24.5",
    r: "1.5"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M20,30H7a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,7,2H20V4H7V28H20V24h2v4A2.0023,2.0023,0,0,1,20,30Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  AugmentedReality.propTypes = iconPropTypes;
}
const WatsonHealthAutoScroll = /*#__PURE__*/React.forwardRef(function WatsonHealthAutoScroll({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M12,16a4,4,0,1,0,4-4A4,4,0,0,0,12,16Zm6,0a2,2,0,1,1-2-2A2,2,0,0,1,18,16Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M16 27.17L10.4 21.58 9 23 16 30 23 23 21.59 21.59 16 27.17z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4.83L21.58 10.4 23 9 16 2 9 9 10.41 10.41 16 4.83z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthAutoScroll.propTypes = iconPropTypes;
}
const Automatic = /*#__PURE__*/React.forwardRef(function Automatic({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M26,16H22a2.002,2.002,0,0,0-2,2V30h2V25h4v5h2V18A2.002,2.002,0,0,0,26,16Zm-4,7V18h4v5Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M16,27a10.9862,10.9862,0,0,1-9.2156-5H12V20H4v8H6V24.3149A13.0239,13.0239,0,0,0,16,29Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M20,10h5.2155A10.9973,10.9973,0,0,0,5,16H3A13.0048,13.0048,0,0,1,26,7.6849V4h2v8H20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Automatic.propTypes = iconPropTypes;
}
const Autoscaling = /*#__PURE__*/React.forwardRef(function Autoscaling({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M22,28H12V26H22V10H6V20H4V10A2.0021,2.0021,0,0,1,6,8H22a2.0021,2.0021,0,0,1,2,2V26A2.0021,2.0021,0,0,1,22,28Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M28,22H26V20h2V4H12V6H10V4a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2V20A2.0021,2.0021,0,0,1,28,22Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14L10 16 14.586 16 3 27.586 4.414 29 16 17.414 16 22 18 22 18 14 10 14z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Autoscaling.propTypes = iconPropTypes;
}
const Avro = /*#__PURE__*/React.forwardRef(function Avro({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M5,11h-2c-1.1,0-2,.9-2,2v8h2v-4h2v4h2v-8c0-1.1-.9-2-2-2ZM5,15h-2v-2h2v2ZM21,11h-4v10h2v-4h.4l1.6,4h2l-1.6-4c.9-.2,1.6-1,1.6-2v-2c0-1.1-.9-2-2-2ZM21,15h-2v-2h2v2ZM12,18l-1-7h-2l2,10h2l2-10h-2l-1,7ZM29,11h-2c-1.1,0-2,.9-2,2v6c0,1.1.9,2,2,2h2c1.1,0,2-.9,2-2v-6c0-1.1-.9-2-2-2ZM29,19h-2v-6h2v6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Avro.propTypes = iconPropTypes;
}
const Awake = /*#__PURE__*/React.forwardRef(function Awake({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
      d: "M7.5 1H8.5V3.5H7.5z"
    })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
      d: "M10.8 3.4H13.3V4.4H10.8z",
      transform: "rotate(-45.001 12.074 3.922)"
    })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
      d: "M12.5 7.5H15V8.5H12.5z"
    })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
      d: "M11.6 10.8H12.6V13.3H11.6z",
      transform: "rotate(-45.001 12.077 12.075)"
    })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
      d: "M7.5 12.5H8.5V15H7.5z"
    })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
      d: "M2.7 11.6H5.2V12.6H2.7z",
      transform: "rotate(-45.001 3.929 12.078)"
    })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
      d: "M1 7.5H3.5V8.5H1z"
    })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
      d: "M3.4 2.7H4.4V5.2H3.4z",
      transform: "rotate(-45.001 3.926 3.925)"
    })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
      d: "M8,6c1.1,0,2,0.9,2,2s-0.9,2-2,2S6,9.1,6,8S6.9,6,8,6 M8,5C6.3,5,5,6.3,5,8s1.3,3,3,3s3-1.3,3-3S9.7,5,8,5z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H17V6.96H15z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M21.67 6.85H26.630000000000003V8.85H21.67z",
    transform: "rotate(-45 24.142 7.85)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M25.04 15H30V17H25.04z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M23.15 21.67H25.15V26.630000000000003H23.15z",
    transform: "rotate(-45 24.152 24.146)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M15 25.04H17V30H15z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M5.37 23.15H10.33V25.15H5.37z",
    transform: "rotate(-45 7.86 24.144)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15H6.96V17H2z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85 5.37H8.85V10.33H6.85z",
    transform: "rotate(-45 7.85 7.848)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M16,12a4,4,0,1,1-4,4,4,4,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Awake.propTypes = iconPropTypes;
}
const Badge = /*#__PURE__*/React.forwardRef(function Badge({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M23 2L24.593 5 28 5.414 25.5 7.667 26 11 23 9.125 20 11 20.5 7.667 18 5.414 21.5 5 23 2z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7168,13.249l-1.9375-.498A6.9942,6.9942,0,1,1,15.7505,4.22l.499-1.9365A8.99,8.99,0,0,0,8,17.689V30l6-4,6,4V17.7078A8.9627,8.9627,0,0,0,22.7168,13.249ZM18,26.2627l-4-2.6665-4,2.6665V19.05a8.9238,8.9238,0,0,0,8,.0062Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Badge.propTypes = iconPropTypes;
}
const BaggageClaim = /*#__PURE__*/React.forwardRef(function BaggageClaim({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: "6",
    cy: "26",
    r: "2"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M28,18H25V16a2.0023,2.0023,0,0,0-2-2H19a2.0023,2.0023,0,0,0-2,2v2H14a2.0023,2.0023,0,0,0-2,2v8a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V20A2.0023,2.0023,0,0,0,28,18Zm-9-2h4v2H19Zm9,12H14V20H28Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M10,6h4v6h2V6h4v6h2V6h4v6h2V6.0049A2.0047,2.0047,0,0,0,25.9951,4H4.0049A2.0047,2.0047,0,0,0,2,6.0049v13.99A2.0047,2.0047,0,0,0,4.0049,22H10ZM8,20H4V6H8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BaggageClaim.propTypes = iconPropTypes;
}
const Bar = /*#__PURE__*/React.forwardRef(function Bar({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M25,11H15a1,1,0,0,0-1,1v4a6.0046,6.0046,0,0,0,5,5.91V28H16v2h8V28H21V21.91A6.0046,6.0046,0,0,0,26,16V12A1,1,0,0,0,25,11Zm-1,5a4,4,0,0,1-8,0V13h8Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M15,1H10A1,1,0,0,0,9,2V9.3706A6.09,6.09,0,0,0,6,15V29a1,1,0,0,0,1,1h5V28H8V15c0-3.1875,2.231-4.02,2.3164-4.0513L11,10.7207V3h3V8h2V2A1,1,0,0,0,15,1Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Bar.propTypes = iconPropTypes;
}
const Barcode = /*#__PURE__*/React.forwardRef(function Barcode({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6H4V28H2z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6H14V26H12z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H10V26H6z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6H20V26H16z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M22 6H26V26H22z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M28 6H30V28H28z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Barcode.propTypes = iconPropTypes;
}
const BareMetalServer = /*#__PURE__*/React.forwardRef(function BareMetalServer({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "6",
    r: "1"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M26,10H6A2.0021,2.0021,0,0,1,4,8V4A2.0021,2.0021,0,0,1,6,2H26a2.0021,2.0021,0,0,1,2,2V8A2.0021,2.0021,0,0,1,26,10ZM6,4V8H26V4Z"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "16",
    r: "1"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M26,20H6a2.0021,2.0021,0,0,1-2-2V14a2.0021,2.0021,0,0,1,2-2H26a2.0021,2.0021,0,0,1,2,2v4A2.0021,2.0021,0,0,1,26,20ZM6,14v4H26V14Z"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "26",
    r: "1"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H6a2.0021,2.0021,0,0,1-2-2V24a2.0021,2.0021,0,0,1,2-2H26a2.0021,2.0021,0,0,1,2,2v4A2.0021,2.0021,0,0,1,26,30ZM6,24v4H26V24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BareMetalServer.propTypes = iconPropTypes;
}
const BareMetalServer_01 = /*#__PURE__*/React.forwardRef(function BareMetalServer_01({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M17 28L17 22 15 22 15 28 5 28 5 30 27 30 27 28 17 28z"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "16",
    r: "1"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M26,20H6a2.0023,2.0023,0,0,1-2-2V14a2.0023,2.0023,0,0,1,2-2H26a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,26,20ZM6,14v4H26V14Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BareMetalServer_01.propTypes = iconPropTypes;
}
const BareMetalServer_02 = /*#__PURE__*/React.forwardRef(function BareMetalServer_02({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M17 28L17 22 15 22 15 28 5 28 5 30 27 30 27 28 17 28z"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "16",
    r: "1"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M26,20H6a2.0023,2.0023,0,0,1-2-2V14a2.0023,2.0023,0,0,1,2-2H26a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,26,20ZM6,14v4H26V14Z"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "6",
    r: "1"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M26,10H6A2.0023,2.0023,0,0,1,4,8V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V8A2.0023,2.0023,0,0,1,26,10ZM6,4V8H26V4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BareMetalServer_02.propTypes = iconPropTypes;
}
const QBarrier = /*#__PURE__*/React.forwardRef(function QBarrier({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5H17V9H15z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11H17V15H15z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M15 17H17V21H15z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M15 23H17V27H15z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  QBarrier.propTypes = iconPropTypes;
}
const Basketball = /*#__PURE__*/React.forwardRef(function Basketball({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM27.9492,15H22.041a14.4088,14.4088,0,0,1,2.7383-7.1533A11.9392,11.9392,0,0,1,27.9492,15ZM17,15V4.0508a11.9181,11.9181,0,0,1,6.2874,2.4375A16.2646,16.2646,0,0,0,20.04,15Zm-2,0H11.96A16.2646,16.2646,0,0,0,8.7126,6.4883,11.9181,11.9181,0,0,1,15,4.0508Zm0,2V27.9492a11.9181,11.9181,0,0,1-6.2874-2.4375A16.2646,16.2646,0,0,0,11.96,17Zm2,0h3.04a16.2646,16.2646,0,0,0,3.2476,8.5117A11.9181,11.9181,0,0,1,17,27.9492ZM7.2207,7.8467A14.4088,14.4088,0,0,1,9.959,15H4.0508A11.9392,11.9392,0,0,1,7.2207,7.8467ZM4.0508,17H9.959a14.4088,14.4088,0,0,1-2.7383,7.1533A11.9392,11.9392,0,0,1,4.0508,17Zm20.7285,7.1533A14.4088,14.4088,0,0,1,22.041,17h5.9082A11.9392,11.9392,0,0,1,24.7793,24.1533Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Basketball.propTypes = iconPropTypes;
}
const BastionHost = /*#__PURE__*/React.forwardRef(function BastionHost({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5273,2.709A1.9955,1.9955,0,0,0,26,2H23.3091a1.5,1.5,0,0,0-1.3419.8294L21.3818,4H20V3.5A1.5,1.5,0,0,0,18.5,2h-5A1.5,1.5,0,0,0,12,3.5V4H10.6182l-.585-1.17A1.5017,1.5017,0,0,0,8.69,2H6A2,2,0,0,0,4.0283,4.333L4.7324,8.5A3,3,0,0,0,7.69,11H8V23a3.0033,3.0033,0,0,0-3,3v4H27V26a3.0033,3.0033,0,0,0-3-3V11h.31a3,3,0,0,0,2.9579-2.5l.7041-4.167A1.994,1.994,0,0,0,27.5273,2.709ZM25,26v2H7V26a1.0009,1.0009,0,0,1,1-1H24A1.0009,1.0009,0,0,1,25,26Zm-3-3H10V11H22ZM25.2959,8.167A.9976.9976,0,0,1,24.31,9H7.69a.9976.9976,0,0,1-.9863-.8335L6,4H8.3818l1,2H14V4h4V6h4.6172l1.001-2H26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BastionHost.propTypes = iconPropTypes;
}
const Bat = /*#__PURE__*/React.forwardRef(function Bat({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9093,6.584A1,1,0,0,0,31,6c-4.7683,0-8.2607.8887-11,2.8438V3H18V6H14V3H12V8.8438C9.2608,6.8887,5.7684,6,1,6A1,1,0,0,0,.2437,7.6543C1.9454,9.6221,3,11.7041,3,16a1,1,0,0,0,1,1c2.7678,0,6,1.31,6,5a1.004,1.004,0,0,0,.9341.998C11.35,23.0273,15,23.3872,15,27a1,1,0,0,0,2,0c0-3.6128,3.65-3.9727,4.0622-4.002A1,1,0,0,0,22,22c0-3.69,3.2321-5,6-5a1,1,0,0,0,1-1c0-4.2959,1.0547-6.3779,2.7564-8.3457A1,1,0,0,0,31.9093,6.584Zm-4.893,8.46c-3.3857.3081-6.5534,2.229-6.97,6.0786A6.552,6.552,0,0,0,16,23.6094a6.552,6.552,0,0,0-4.0461-2.4864c-.4168-3.85-3.5845-5.7705-6.97-6.0786a13.2017,13.2017,0,0,0-1.9387-6.98c4.1318.2724,7.0327,1.4277,9.248,3.6425A1,1,0,0,0,14,11V8h4v3a1,1,0,0,0,1.707.707c2.2153-2.2148,5.1162-3.37,9.248-3.6425A13.2017,13.2017,0,0,0,27.0163,15.0444Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Bat.propTypes = iconPropTypes;
}
const BatchJob = /*#__PURE__*/React.forwardRef(function BatchJob({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M32,26v-2h-2.1011c-.1299-.6372-.3843-1.2285-.7319-1.7529l1.4897-1.4897-1.4141-1.4141-1.4897,1.4897c-.5244-.3477-1.1157-.6021-1.7529-.7319v-2.1011h-2v2.1011c-.6372,.1299-1.2285,.3843-1.7529,.7319l-1.4897-1.4897-1.4141,1.4141,1.4897,1.4897c-.3477,.5244-.6021,1.1157-.7319,1.7529h-2.1011v2h2.1011c.1299,.6372,.3843,1.2285,.7319,1.7529l-1.4897,1.4897,1.4141,1.4141,1.4897-1.4897c.5244,.3477,1.1157,.6021,1.7529,.7319v2.1011h2v-2.1011c.6372-.1299,1.2285-.3843,1.7529-.7319l1.4897,1.4897,1.4141-1.4141-1.4897-1.4897c.3477-.5244,.6021-1.1157,.7319-1.7529h2.1011Zm-7,2c-1.6543,0-3-1.3457-3-3s1.3457-3,3-3,3,1.3457,3,3-1.3457,3-3,3Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M20,17H12c-1.1046,0-2-.8954-2-2V4c0-1.1046,.8954-2,2-2h8c1.1046,0,2,.8954,2,2V15c0,1.1046-.8954,2-2,2Zm-8-2h8V4H12V15Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M17,21H8c-1.1046,0-2-.8954-2-2V7h2v12h9v2Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M13,25H4c-1.1028,0-2-.8972-2-2V11h2v12H13v2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BatchJob.propTypes = iconPropTypes;
}
const BatchJobStep = /*#__PURE__*/React.forwardRef(function BatchJobStep({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M24 20L24 24 20 24 20 28 16 28 16 30 22 30 22 26 26 26 26 22 30 22 30 20 24 20z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M8,4h8v6c0,1.1025,.8972,2,2,2h6v4h2v-6c0-.2651-.1055-.5195-.293-.707l-7-7c-.1875-.1875-.4419-.293-.707-.293H8c-1.1028,0-2,.8975-2,2V28c0,1.1025,.8972,2,2,2h4v-2h-4V4Zm15.5857,6h-5.5857V4.4141l5.5857,5.5859Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BatchJobStep.propTypes = iconPropTypes;
}
const BatteryCharging = /*#__PURE__*/React.forwardRef(function BatteryCharging({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M27,11H26V10a2,2,0,0,0-2-2H20v2h4v3h3v6H24v3H19v2h5a2,2,0,0,0,2-2V21h1a2,2,0,0,0,2-2V13A2,2,0,0,0,27,11Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M11,22H6V10h6V8H6a2,2,0,0,0-2,2V22a2,2,0,0,0,2,2h5Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M14.81 23.58L13.19 22.42 17.06 17 9.37 17 16.22 8.38 17.78 9.62 13.51 15 20.94 15 14.81 23.58z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BatteryCharging.propTypes = iconPropTypes;
}
const BatteryEmpty = /*#__PURE__*/React.forwardRef(function BatteryEmpty({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M24,24H6a2.0023,2.0023,0,0,1-2-2V10A2.002,2.002,0,0,1,6,8H24a2.0023,2.0023,0,0,1,2,2v1h1a2.0023,2.0023,0,0,1,2,2v6a2.0027,2.0027,0,0,1-2,2H26v1A2.0027,2.0027,0,0,1,24,24ZM6,10V22H24V19h3V13H24V10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BatteryEmpty.propTypes = iconPropTypes;
}
const BatteryError = /*#__PURE__*/React.forwardRef(function BatteryError({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M27,11h-1v-1c0-1.1-.9-2-2-2h-7v2h7v3h3v6h-3v3H6v-5h-2v5c0,1.1.9,2,2,2h18c1.1,0,2-.9,2-2v-1h1c1.1,0,2-.9,2-2v-6c0-1.1-.9-2-2-2ZM9,15c3.31,0,6-2.69,6-6s-2.69-6-6-6-6,2.69-6,6,2.69,6,6,6ZM9,5c2.21,0,4,1.79,4,4,0,.71-.2,1.41-.57,2.02l-5.45-5.45c.61-.37,1.31-.56,2.02-.57ZM5.57,6.98l5.45,5.45c-.61.37-1.31.56-2.02.57-2.21,0-4-1.79-4-4,0-.71.2-1.41.57-2.02Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BatteryError.propTypes = iconPropTypes;
}
const BatteryFull = /*#__PURE__*/React.forwardRef(function BatteryFull({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M24,24H6a2,2,0,0,1-2-2V10A2,2,0,0,1,6,8H24a2,2,0,0,1,2,2v1h1a2,2,0,0,1,2,2v6a2,2,0,0,1-2,2H26v1A2,2,0,0,1,24,24ZM6,10V22H24V19h3V13H24V10Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M11 9H19V23H11z",
    transform: "rotate(90 15 16)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BatteryFull.propTypes = iconPropTypes;
}
const BatteryHalf = /*#__PURE__*/React.forwardRef(function BatteryHalf({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M24,24H6a2,2,0,0,1-2-2V10A2,2,0,0,1,6,8H24a2,2,0,0,1,2,2v1h1a2,2,0,0,1,2,2v6a2,2,0,0,1-2,2H26v1A2,2,0,0,1,24,24ZM6,10V22H24V19h3V13H24V10Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12H16V20H8z",
    transform: "rotate(90 12 16)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BatteryHalf.propTypes = iconPropTypes;
}
const BatteryLow = /*#__PURE__*/React.forwardRef(function BatteryLow({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M24,24H6a2.0023,2.0023,0,0,1-2-2V10A2.002,2.002,0,0,1,6,8H24a2.0023,2.0023,0,0,1,2,2v1h1a2.0023,2.0023,0,0,1,2,2v6a2.0027,2.0027,0,0,1-2,2H26v1A2.0027,2.0027,0,0,1,24,24ZM6,10V22H24V19h3V13H24V10Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M5 15H13V17H5z",
    transform: "rotate(90 9 16)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BatteryLow.propTypes = iconPropTypes;
}
const BatteryQuarter = /*#__PURE__*/React.forwardRef(function BatteryQuarter({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M24,24H6a2.0023,2.0023,0,0,1-2-2V10A2.002,2.002,0,0,1,6,8H24a2.0023,2.0023,0,0,1,2,2v1h1a2.0023,2.0023,0,0,1,2,2v6a2.0027,2.0027,0,0,1-2,2H26v1A2.0027,2.0027,0,0,1,24,24ZM6,10V22H24V19h3V13H24V10Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M6 14H14V18H6z",
    transform: "rotate(90 10 16)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BatteryQuarter.propTypes = iconPropTypes;
}
const BatteryWarning = /*#__PURE__*/React.forwardRef(function BatteryWarning({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M27,11h-1v-1c0-1.1-.9-2-2-2h-10v2h10v3h3v6h-3v3H6v-5h-2v5c0,1.1.9,2,2,2h18c1.1,0,2-.9,2-2v-1h1c1.1,0,2-.9,2-2v-6c0-1.1-.9-2-2-2ZM14,14c0-.13-.03-.27-.08-.39L8.89,3.55c-.17-.34-.52-.55-.89-.55-.38,0-.73.21-.89.55L2.11,13.55c-.25.49-.05,1.1.45,1.34.14.07.29.11.45.11h10c.55,0,1-.45,1-1h-.01ZM4.62,13l3.38-6.76,3.38,6.76h-6.76Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BatteryWarning.propTypes = iconPropTypes;
}
const Bee = /*#__PURE__*/React.forwardRef(function Bee({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M16,10a6,6,0,0,0-6,6v8a6,6,0,0,0,12,0V16A6,6,0,0,0,16,10Zm-4.25,7.87h8.5v4.25h-8.5ZM16,28.25A4.27,4.27,0,0,1,11.75,24v-.13h8.5V24A4.27,4.27,0,0,1,16,28.25Zm4.25-12.13h-8.5V16a4.25,4.25,0,0,1,8.5,0Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M30.66,19.21,24,13v9.1a4,4,0,0,0,8,0A3.83,3.83,0,0,0,30.66,19.21ZM28,24.35a2.25,2.25,0,0,1-2.25-2.25V17l3.72,3.47h0A2.05,2.05,0,0,1,30.2,22,2.25,2.25,0,0,1,28,24.35Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M0,22.1a4,4,0,0,0,8,0V13L1.34,19.21A3.88,3.88,0,0,0,0,22.1Zm2.48-1.56h0L6.25,17v5.1a2.25,2.25,0,0,1-4.5,0A2.05,2.05,0,0,1,2.48,20.54Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M15,5.5A3.5,3.5,0,1,0,11.5,9,3.5,3.5,0,0,0,15,5.5Zm-5.25,0A1.75,1.75,0,1,1,11.5,7.25,1.77,1.77,0,0,1,9.75,5.5Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5,2A3.5,3.5,0,1,0,24,5.5,3.5,3.5,0,0,0,20.5,2Zm0,5.25A1.75,1.75,0,1,1,22.25,5.5,1.77,1.77,0,0,1,20.5,7.25Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Bee.propTypes = iconPropTypes;
}
const BeeBat = /*#__PURE__*/React.forwardRef(function BeeBat({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: "13",
    cy: "8",
    r: "2"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: "19",
    cy: "8",
    r: "2"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8083,8.665A.8745.8745,0,0,0,31,8.125H29c-4.21,0-7.721,2.002-9.1648,4.9014a4.8186,4.8186,0,0,0-7.67,0C10.721,10.127,7.21,8.125,3,8.125H1A.8749.8749,0,0,0,.3816,9.6191L.4834,9.72A5.3885,5.3885,0,0,1,2.1612,15.751.8751.8751,0,0,0,3,16.875a2.8966,2.8966,0,0,1,2.1587.7266c.9783.9814.9714,2.8872.9668,4.1479l0,.25A.875.875,0,0,0,7,22.875h4.125V23a4.875,4.875,0,0,0,9.75,0v-.125H25A.875.875,0,0,0,25.875,22l0-.25c-.0046-1.2607-.0115-3.1665.9668-4.1479A2.8966,2.8966,0,0,1,29,16.875a.8751.8751,0,0,0,.8388-1.124,5.3883,5.3883,0,0,1,1.6765-6.0293l.1033-.103A.875.875,0,0,0,31.8083,8.665ZM16,12.875A3.1286,3.1286,0,0,1,19.125,16v.125h-6.25V16A3.1286,3.1286,0,0,1,16,12.875Zm-3.125,5h6.25v3.25h-6.25Zm-5.0007,3.25c-.0178-1.459-.1839-3.4619-1.4761-4.7588a4.1876,4.1876,0,0,0-2.31-1.1518A6.657,6.657,0,0,0,2.9524,9.875H3c4.5562,0,8.125,2.69,8.125,6.125v5.125ZM19.125,23a3.125,3.125,0,0,1-6.25,0v-.125h6.25Zm8.7868-7.7856a4.1876,4.1876,0,0,0-2.31,1.1518c-1.2922,1.2969-1.4583,3.3-1.4761,4.7588H20.875V16c0-3.4346,3.5688-6.125,8.125-6.125h.0481A6.6561,6.6561,0,0,0,27.9118,15.2144Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BeeBat.propTypes = iconPropTypes;
}
const Beta = /*#__PURE__*/React.forwardRef(function Beta({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7168,13.7705A5.9174,5.9174,0,0,0,23,9c0-3.5327-2.8784-6-7-6a6.627,6.627,0,0,0-7,7V31h2V25.1206a8.1261,8.1261,0,0,0,6,2.48A7.3833,7.3833,0,0,0,24.6528,20,6.6364,6.6364,0,0,0,20.7168,13.7705ZM17,25.6A5.6781,5.6781,0,0,1,11,20V10a4.6856,4.6856,0,0,1,5-5c3.0374,0,5,1.57,5,4a3.8732,3.8732,0,0,1-4,4v2c3.4341,0,5.6528,1.9629,5.6528,5A5.3907,5.3907,0,0,1,17,25.6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Beta.propTypes = iconPropTypes;
}
const Bicycle = /*#__PURE__*/React.forwardRef(function Bicycle({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M26,16c-.0879,0-.1731.0093-.26.0132L24.2368,9H28V7H23a1,1,0,0,0-.978,1.21L22.62,11H12.3872l-1-3H14V6H7V8H9.28l1.0411,3.123-2.57,5.1392A6,6,0,1,0,11.91,23h2.61a1.991,1.991,0,0,0,1.5616-.75L23.14,13.4258l.6436,3.0039A5.9891,5.9891,0,1,0,26,16ZM6,26a4,4,0,1,1,.8364-7.9092L5.1055,21.5527l.009.0044A.9834.9834,0,0,0,5,22a.9931.9931,0,0,0,1.8853.4429l.0092.0044L8.6182,19A3.9835,3.9835,0,0,1,6,26Zm5.91-5a5.9986,5.9986,0,0,0-2.3733-3.8364l1.6787-3.3574L13.613,21Zm3.4577-1.06L13.054,13h7.8654ZM26,26a3.9882,3.9882,0,0,1-1.7859-7.56l.8079,3.77.02-.0044A.9859.9859,0,0,0,26,23a1,1,0,0,0,1-1,.9456.9456,0,0,0-.0415-.2056l.02-.0044-.8086-3.7729A3.9931,3.9931,0,0,1,26,26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Bicycle.propTypes = iconPropTypes;
}
const Binding_01 = /*#__PURE__*/React.forwardRef(function Binding_01({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M4 10H28V12H4z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M4 20H28V22H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Binding_01.propTypes = iconPropTypes;
}
const Binding_02 = /*#__PURE__*/React.forwardRef(function Binding_02({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M25 8L23.3721 9.1621 28.542 16 23.386 22.8379 25.0139 24 31 16 25 8z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M20 8L18.3721 9.1621 23.542 16 18.386 22.8379 20.0139 24 26 16 20 8z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M8.6279 9.1621L7 8 1 16 6.9861 24 8.614 22.8379 3.458 16 8.6279 9.1621z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M12 8L6 16 11.9861 24 13.614 22.8379 8.458 16 13.6279 9.1621 12 8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Binding_02.propTypes = iconPropTypes;
}
const Binoculars = /*#__PURE__*/React.forwardRef(function Binoculars({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M28,8V5a1,1,0,0,0-1-1H21a1,1,0,0,0-1,1V8a2,2,0,0,0-2,2v2H14V10a2,2,0,0,0-2-2V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V8a2,2,0,0,0-2,2V22a2,2,0,0,0,1,1.72V27a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V23.72A2,2,0,0,0,14,22V20h4v2a2,2,0,0,0,1,1.72V27a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V23.72A2,2,0,0,0,30,22V10A2,2,0,0,0,28,8ZM11,26H5V24h6Zm1-4H4V10H6V6h4v4h2Zm2-4V14h4v4Zm13,8H21V24h6Zm1-4H20V10h2V6h4v4h2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Binoculars.propTypes = iconPropTypes;
}
const BlandAltmanPlot = /*#__PURE__*/React.forwardRef(function BlandAltmanPlot({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M10,22c1.1,0,2,.9,2,2s-.9,2-2,2-2-.9-2-2,.9-2,2-2ZM17,18c1.1,0,2,.9,2,2s-.9,2-2,2-2-.9-2-2,.9-2,2-2ZM24,22c1.1,0,2,.9,2,2s-.9,2-2,2-2-.9-2-2,.9-2,2-2ZM30,16v-2H4V2h-2v26c0,1.1.9,2,2,2h26v-2H4v-12h26ZM10,8c1.1,0,2,.9,2,2s-.9,2-2,2-2-.9-2-2,.9-2,2-2ZM17,8c1.1,0,2,.9,2,2s-.9,2-2,2-2-.9-2-2,.9-2,2-2ZM28,2c1.1,0,2,.9,2,2s-.9,2-2,2-2-.9-2-2,.9-2,2-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BlandAltmanPlot.propTypes = iconPropTypes;
}
const QBlochSphere = /*#__PURE__*/React.forwardRef(function QBlochSphere({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M21.87,7.84l-1.74-1L16,14h0a2,2,0,1,0,2,2,2,2,0,0,0-.27-1Z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,2a12,12,0,0,1,11.17,7.65,25.69,25.69,0,0,0-3.69-1.5l-1,1.77a22.7,22.7,0,0,1,5.41,2.39,11.05,11.05,0,0,1,0,3.38A22.92,22.92,0,0,1,16,21,22.92,22.92,0,0,1,4.13,17.69a11.05,11.05,0,0,1,0-3.38A22.8,22.8,0,0,1,15,11V9a25,25,0,0,0-10.17,2.6A12,12,0,0,1,16,4Zm0,24A12,12,0,0,1,4.83,20.35,24.88,24.88,0,0,0,16,23a24.88,24.88,0,0,0,11.17-2.65A12,12,0,0,1,16,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  QBlochSphere.propTypes = iconPropTypes;
}
const BlockStorage = /*#__PURE__*/React.forwardRef(function BlockStorage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M9,12V10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V19H20v9H4V12"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M22,12H14V4h8ZM12,4v8a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2H14A2,2,0,0,0,12,4Z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M14,18v4H10V18h4M8,18v4a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V18a2,2,0,0,0-2-2H10A2,2,0,0,0,8,18Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M28,17v2H26V17h2m-4-1v4a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V16a1,1,0,0,0-1-1H25A1,1,0,0,0,24,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BlockStorage.propTypes = iconPropTypes;
}
const BlockStorageAlt = /*#__PURE__*/React.forwardRef(function BlockStorageAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "25",
    r: "1"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M15,20H8V13h7Zm-5-2h3V15H10Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M24,20H17V13h7Zm-5-2h3V15H19Z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M15,11H8V4h7ZM10,9h3V6H10Z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M24,11H17V4h7ZM19,9h3V6H19Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BlockStorageAlt.propTypes = iconPropTypes;
}
const Blockchain = /*#__PURE__*/React.forwardRef(function Blockchain({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M6,24H4V8H6ZM28,8H26V24h2ZM24,6V4H8V6Zm0,22V26H8v2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Blockchain.propTypes = iconPropTypes;
}
const Blog = /*#__PURE__*/React.forwardRef(function Blog({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M4 24H14V26H4z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M4 18H14V20H4z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M26,14H6a2,2,0,0,1-2-2V6A2,2,0,0,1,6,4H26a2,2,0,0,1,2,2v6A2,2,0,0,1,26,14ZM6,6v6H26V6Z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M26,28H20a2,2,0,0,1-2-2V20a2,2,0,0,1,2-2h6a2,2,0,0,1,2,2v6A2,2,0,0,1,26,28Zm-6-8v6h6V20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Blog.propTypes = iconPropTypes;
}
const Bluetooth = /*#__PURE__*/React.forwardRef(function Bluetooth({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30a1.06,1.06,0,0,1-.42-.09A1,1,0,0,1,15,29V18.41L8.41,25,7,23.59,14.59,16,7,8.41,8.41,7,15,13.59V3a1,1,0,0,1,.58-.91,1,1,0,0,1,1.07.15l7,6A1,1,0,0,1,24,9a1,1,0,0,1-.29.75L17.41,16l6.3,6.29A1,1,0,0,1,24,23a1,1,0,0,1-.35.72l-7,6A1,1,0,0,1,16,30Zm1-11.59v8.42l4.53-3.89ZM17,5.17v8.42l4.53-4.53Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Bluetooth.propTypes = iconPropTypes;
}
const BluetoothOff = /*#__PURE__*/React.forwardRef(function BluetoothOff({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M28,26.59,5.41,4,4,5.41,14.59,16,7,23.59,8.41,25,15,18.41V29a1,1,0,0,0,.58.91A1.06,1.06,0,0,0,16,30a1,1,0,0,0,.65-.24l6.3-5.4L26.59,28Zm-11,.24V18.41l4.53,4.53Z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M17,12.75V5.17l4.53,3.89-4.11,4.11,1.41,1.41,4.88-4.87A1,1,0,0,0,24,9a1,1,0,0,0-.35-.72l-7-6a1,1,0,0,0-1.07-.15A1,1,0,0,0,15,3v7.75Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BluetoothOff.propTypes = iconPropTypes;
}
const Book = /*#__PURE__*/React.forwardRef(function Book({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M19 10H26V12H19z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M19 15H26V17H19z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M19 20H26V22H19z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10H13V12H6z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15H13V17H6z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M6 20H13V22H6z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M28,5H4A2.002,2.002,0,0,0,2,7V25a2.002,2.002,0,0,0,2,2H28a2.002,2.002,0,0,0,2-2V7A2.002,2.002,0,0,0,28,5ZM4,7H15V25H4ZM17,25V7H28V25Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Book.propTypes = iconPropTypes;
}
const Bookmark = /*#__PURE__*/React.forwardRef(function Bookmark({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M24,4V26.75l-7.1-3.59-.9-.45-.9.45L8,26.75V4H24m0-2H8A2,2,0,0,0,6,4V30L16,25,26,30V4A2,2,0,0,0,24,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Bookmark.propTypes = iconPropTypes;
}
const BookmarkAdd = /*#__PURE__*/React.forwardRef(function BookmarkAdd({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M24,16V26.7515l-7.0962-3.5894L16,22.7051l-.9009.456L8,26.748V4H18V2H8A2,2,0,0,0,6,4V30l10-5.0537L26,30V16Z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M26 6L26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6 26 6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BookmarkAdd.propTypes = iconPropTypes;
}
const BookmarkFilled = /*#__PURE__*/React.forwardRef(function BookmarkFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M24,2H8A2,2,0,0,0,6,4V30l10-5.0538L26,30V4A2,2,0,0,0,24,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BookmarkFilled.propTypes = iconPropTypes;
}
const Boolean = /*#__PURE__*/React.forwardRef(function Boolean({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M23,23a7,7,0,1,1,7-7A7.0078,7.0078,0,0,1,23,23Zm0-12a5,5,0,1,0,5,5A5.0055,5.0055,0,0,0,23,11Z"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "16",
    r: "7"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Boolean.propTypes = iconPropTypes;
}
const Boot = /*#__PURE__*/React.forwardRef(function Boot({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M24,17H18a1.0008,1.0008,0,0,1-1-1V4a2.0025,2.0025,0,0,0-2-2H5A2.0025,2.0025,0,0,0,3,4V28a2.0025,2.0025,0,0,0,2,2H27a2.0025,2.0025,0,0,0,2-2V22A5.0057,5.0057,0,0,0,24,17Zm3,5v2H23V19h1A3.0033,3.0033,0,0,1,27,22ZM15,4V6H11V8h4v2H11v2h4v2H11v2h4a3.0033,3.0033,0,0,0,3,3h3v5H14.1624l-3-1H5V4ZM25,28V27H23v1H21V27H19v1H17V27H15v1H13V27H11v1H5V25h5.8376l3,1H27v2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Boot.propTypes = iconPropTypes;
}
const BootVolume = /*#__PURE__*/React.forwardRef(function BootVolume({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M32,22v-2h-3v-2h-2v2h-1v2h1v6c0,1.1025,.8975,2,2,2h3v-2h-3v-6h3Z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M23,30h-3c-1.1025,0-2-.8975-2-2v-6c0-1.103,.8975-2,2-2h3c1.1025,0,2,.897,2,2v6c0,1.1025-.8975,2-2,2Zm-3-8v6h3v-6h-3Z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M14,30h-3c-1.1025,0-2-.8975-2-2v-6c0-1.103,.8975-2,2-2h3c1.1025,0,2,.897,2,2v6c0,1.1025-.8975,2-2,2Zm-3-8v6h3v-6h-3Z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M5,20H2v-4H0v14H5c1.1025,0,2-.8975,2-2v-6c0-1.103-.8975-2-2-2Zm-3,8v-6h3v6H2Z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M4,14V5h7.5857l4,4h12.4143v7h2v-7c-.0013-1.1041-.8959-1.9987-2-2h-11.5857l-3.4143-3.4141c-.3742-.3764-.8835-.5873-1.4143-.5859H4c-1.1041,.0013-1.9987,.8959-2,2V14h2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BootVolume.propTypes = iconPropTypes;
}
const BootVolumeAlt = /*#__PURE__*/React.forwardRef(function BootVolumeAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30h-7c-1.1028,0-2-.8972-2-2v-2h2v2h7v-7h-2v-2h2c1.1028,0,2,.8972,2,2v7c0,1.1028-.8972,2-2,2Z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M12 24L14 24 13.9998 17.414 22.5823 26 24 24.5857 15.4139 15.9998 22 16 22 14 12 14 12 24z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M8,27H4c-1.104-.0013-1.9987-.896-2-2V5c.0013-1.104,.896-1.9987,2-2h7.5857c.5308-.0015,1.0401,.2095,1.4143,.5859l3.4143,3.4141h11.5857c1.104,.0013,1.9987,.896,2,2v7h-2v-7H15.5857l-4-4H4V25h4v2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BootVolumeAlt.propTypes = iconPropTypes;
}
const BorderBottom = /*#__PURE__*/React.forwardRef(function BorderBottom({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M3 27H29V29H3z",
    transform: "rotate(180 16 28)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M27 23H29V25H27z",
    transform: "rotate(180 28 24)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M27 19H29V21H27z",
    transform: "rotate(180 28 20)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M27 15H29V17H27z",
    transform: "rotate(180 28 16)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M27 11H29V13H27z",
    transform: "rotate(180 28 12)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M27 7H29V9H27z",
    transform: "rotate(180 28 8)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M27 3H29V5H27z",
    transform: "rotate(180 28 4)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M23 3H25V5H23z",
    transform: "rotate(180 24 4)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M19 3H21V5H19z",
    transform: "rotate(180 20 4)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M15 3H17V5H15z",
    transform: "rotate(180 16 4)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M7 3H9V5H7z",
    transform: "rotate(180 8 4)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M11 3H13V5H11z",
    transform: "rotate(180 12 4)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M3 23H5V25H3z",
    transform: "rotate(180 4 24)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M3 19H5V21H3z",
    transform: "rotate(180 4 20)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M3 15H5V17H3z",
    transform: "rotate(180 4 16)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M3 11H5V13H3z",
    transform: "rotate(180 4 12)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M3 7H5V9H3z",
    transform: "rotate(180 4 8)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3H5V5H3z",
    transform: "rotate(180 4 4)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H18V12H8z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15H14V17H8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BorderBottom.propTypes = iconPropTypes;
}
const BorderFull = /*#__PURE__*/React.forwardRef(function BorderFull({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H18V12H8z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15H14V17H8z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M29,29H3V3H29ZM5,27H27V5H5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BorderFull.propTypes = iconPropTypes;
}
const BorderLeft = /*#__PURE__*/React.forwardRef(function BorderLeft({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M-9 15H17V17H-9z",
    transform: "rotate(-90 4 16)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M7 27H9V29H7z",
    transform: "rotate(-90 8 28)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M11 27H13V29H11z",
    transform: "rotate(-90 12 28)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M15 27H17V29H15z",
    transform: "rotate(-90 16 28)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M19 27H21V29H19z",
    transform: "rotate(-90 20 28)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M23 27H25V29H23z",
    transform: "rotate(-90 24 28)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M27 27H29V29H27z",
    transform: "rotate(-90 28 28)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M27 23H29V25H27z",
    transform: "rotate(-90 28 24)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M27 19H29V21H27z",
    transform: "rotate(-90 28 20)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M27 15H29V17H27z",
    transform: "rotate(-90 28 16)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M27 7H29V9H27z",
    transform: "rotate(-90 28 8)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M27 11H29V13H27z",
    transform: "rotate(-90 28 12)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M7 3H9V5H7z",
    transform: "rotate(-90 8 4)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M11 3H13V5H11z",
    transform: "rotate(-90 12 4)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M15 3H17V5H15z",
    transform: "rotate(-90 16 4)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M19 3H21V5H19z",
    transform: "rotate(-90 20 4)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M23 3H25V5H23z",
    transform: "rotate(-90 24 4)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M27 3H29V5H27z",
    transform: "rotate(-90 28 4)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H18V12H8z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15H14V17H8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BorderLeft.propTypes = iconPropTypes;
}
const BorderNone = /*#__PURE__*/React.forwardRef(function BorderNone({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3H5V5H3z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M7 3H9V5H7z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M11 3H13V5H11z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M15 3H17V5H15z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M3 7H5V9H3z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M3 11H5V13H3z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M3 15H5V17H3z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M3 19H5V21H3z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M3 23H5V25H3z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M3 27H5V29H3z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M27 3H29V5H27z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M23 3H25V5H23z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M19 3H21V5H19z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M7 27H9V29H7z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M11 27H13V29H11z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M15 27H17V29H15z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M23 27H25V29H23z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M19 27H21V29H19z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M27 7H29V9H27z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M27 11H29V13H27z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M27 15H29V17H27z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M27 19H29V21H27z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M27 23H29V25H27z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M27 27H29V29H27z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H18V12H8z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15H14V17H8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BorderNone.propTypes = iconPropTypes;
}
const BorderRight = /*#__PURE__*/React.forwardRef(function BorderRight({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M15 15H41V17H15z",
    transform: "rotate(90 28 16)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M23 3H25V5H23z",
    transform: "rotate(90 24 4)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M19 3H21V5H19z",
    transform: "rotate(90 20 4)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M15 3H17V5H15z",
    transform: "rotate(90 16 4)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M11 3H13V5H11z",
    transform: "rotate(90 12 4)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M7 3H9V5H7z",
    transform: "rotate(90 8 4)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3H5V5H3z",
    transform: "rotate(90 4 4)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M3 7H5V9H3z",
    transform: "rotate(90 4 8)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M3 11H5V13H3z",
    transform: "rotate(90 4 12)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M3 15H5V17H3z",
    transform: "rotate(90 4 16)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M3 23H5V25H3z",
    transform: "rotate(90 4 24)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M3 19H5V21H3z",
    transform: "rotate(90 4 20)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M23 27H25V29H23z",
    transform: "rotate(90 24 28)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M19 27H21V29H19z",
    transform: "rotate(90 20 28)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M15 27H17V29H15z",
    transform: "rotate(90 16 28)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M11 27H13V29H11z",
    transform: "rotate(90 12 28)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M7 27H9V29H7z",
    transform: "rotate(90 8 28)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M3 27H5V29H3z",
    transform: "rotate(90 4 28)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H18V12H8z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15H14V17H8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BorderRight.propTypes = iconPropTypes;
}
const BorderTop = /*#__PURE__*/React.forwardRef(function BorderTop({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3H29V5H3z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M3 7H5V9H3z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M3 11H5V13H3z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M3 15H5V17H3z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M3 19H5V21H3z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M3 23H5V25H3z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M3 27H5V29H3z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M7 27H9V29H7z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M11 27H13V29H11z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M15 27H17V29H15z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M23 27H25V29H23z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M19 27H21V29H19z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M27 7H29V9H27z"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M27 11H29V13H27z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M27 15H29V17H27z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M27 19H29V21H27z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M27 23H29V25H27z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M27 27H29V29H27z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H18V12H8z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15H14V17H8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BorderTop.propTypes = iconPropTypes;
}
const Bot = /*#__PURE__*/React.forwardRef(function Bot({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M18 10H20V12H18z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10H14V12H12z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M26,20H21V18h1a2.0023,2.0023,0,0,0,2-2V12h2V10H24V8a2.0023,2.0023,0,0,0-2-2H20V2H18V6H14V2H12V6H10A2.0023,2.0023,0,0,0,8,8v2H6v2H8v4a2.0023,2.0023,0,0,0,2,2h1v2H6a2.0023,2.0023,0,0,0-2,2v8H6V22H26v8h2V22A2.0023,2.0023,0,0,0,26,20ZM10,8H22v8H10Zm3,10h6v2H13Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Bot.propTypes = iconPropTypes;
}
const Bottles_01 = /*#__PURE__*/React.forwardRef(function Bottles_01({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M26,9.3706V3c0-.5522-.4478-1-1-1h-3v2h2v6.7207s3,.5066,3,4.2793v13h-3v2h4c.5522,0,1-.4478,1-1V15c0-3.4517-1.9326-5.0239-3-5.6294Z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M19,9.3706V3c0-.5522-.4478-1-1-1h-3v2h2v6.7207s3,.5066,3,4.2793v13h-3v2h4c.5522,0,1-.4478,1-1V15c0-3.4517-1.9326-5.0239-3-5.6294Z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M12,9.3706V3c0-.5522-.4478-1-1-1H7c-.5522,0-1,.4478-1,1v6.3706c-1.0674,.6055-3,2.1777-3,5.6294v14c0,.5522,.4478,1,1,1H14c.5522,0,1-.4478,1-1V15c0-3.4517-1.9326-5.0239-3-5.6294Zm1,18.6294H5V15c0-3.7725,3-4.2793,3-4.2793V4h2v6.7207s3,.5068,3,4.2793v13Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Bottles_01.propTypes = iconPropTypes;
}
const Bottles_01Dash = /*#__PURE__*/React.forwardRef(function Bottles_01Dash({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M26,9.3706V3c0-.5522-.4478-1-1-1h-3v2h2v6.7207s3,.5066,3,4.2793v13h-3v2h4c.5522,0,1-.4478,1-1V15c0-3.4517-1.9326-5.0239-3-5.6294Z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M19,9.3706V3c0-.5522-.4478-1-1-1h-3v2h2v6.7207s3,.5066,3,4.2793v13h-3v2h4c.5522,0,1-.4478,1-1V15c0-3.4517-1.9326-5.0239-3-5.6294Z"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M13,28h-3v2h4c.5522,0,1-.4478,1-1v-4h-2v3Z"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M5,25H3v4c0,.5522,.4478,1,1,1h4v-2h-3v-3Z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M13 18H15V23H13z"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M3 18H5V23H3z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M12,9.3706V3c0-.5522-.4478-1-1-1H7c-.5522,0-1,.4478-1,1v6.3706c-1.0674,.6055-3,2.1777-3,5.6294v1h2v-1c0-3.7725,3-4.2793,3-4.2793V4h2v6.7207s3,.5068,3,4.2793v1h2v-1c0-3.4517-1.9326-5.0239-3-5.6294Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Bottles_01Dash.propTypes = iconPropTypes;
}
const Bottles_02 = /*#__PURE__*/React.forwardRef(function Bottles_02({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M24,9.0513v-3.0513c0-.5522-.4478-1-1-1h-3v2h2v3.02s2,1.1238,2,3.48v11.5h-4v2h5c.5522,0,1-.4478,1-1V13.5c0-1.7129-.7229-3.3076-2-4.4487Z"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M16,9.0513v-3.0513c0-.5522-.4478-1-1-1h-6c-.5522,0-1,.4478-1,1v3.0513c-1.2771,1.1411-2,2.7358-2,4.4487v12.5c0,.5522,.4478,1,1,1h10c.5522,0,1-.4478,1-1V13.5c0-1.7129-.7229-3.3076-2-4.4487Zm0,15.9487H8V13.5c0-2.356,2-3.48,2-3.48v-3.02h4v3.02s2,1.124,2,3.48v11.5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Bottles_02.propTypes = iconPropTypes;
}
const Bottles_02Dash = /*#__PURE__*/React.forwardRef(function Bottles_02Dash({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M24,9.0513v-3.0513c0-.5522-.4478-1-1-1h-3v2h2v3.02s2,1.1238,2,3.48v11.5h-4v2h5c.5522,0,1-.4478,1-1V13.5c0-1.7129-.7229-3.3076-2-4.4487Z"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M16,25h-3v2h4c.5522,0,1-.4478,1-1v-4h-2v3Z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M8,22h-2v4c0,.5522,.4478,1,1,1h4v-2h-3v-3Z"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16H18V20H16z"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M6 16H8V20H6z"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M16,9.0513v-3.0513c0-.5522-.4478-1-1-1h-6c-.5522,0-1,.4478-1,1v3.0513c-1.2771,1.1411-2,2.7358-2,4.4487v.5h2v-.5c0-2.356,2-3.48,2-3.48v-3.02h4v3.02s2,1.124,2,3.48v.5h2v-.5c0-1.7129-.7229-3.3076-2-4.4487Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Bottles_02Dash.propTypes = iconPropTypes;
}
const BottlesContainer = /*#__PURE__*/React.forwardRef(function BottlesContainer({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M23,10v-2c0-.5522-.4478-1-1-1h-3v2h2v1.9688s2,1.1238,2,3.48v8.5513h-4v2h5c.5522,0,1-.4478,1-1V14.4487c0-1.7129-.7229-3.3076-2-4.4487Z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M15,10v-2c0-.5522-.4478-1-1-1h-4c-.5522,0-1,.4478-1,1v2c-1.2771,1.1411-2,2.7358-2,4.4487v9.5513c0,.5522,.4478,1,1,1h8c.5522,0,1-.4478,1-1V14.4487c0-1.7129-.7229-3.3076-2-4.4487Zm0,13h-6V14.4487c0-2.356,2-3.48,2-3.48v-1.9688h2v1.9688s2,1.124,2,3.48v8.5513Z"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4c-1.1046,0-2,.8954-2,2V28c0,1.1046,.8954,2,2,2H28c1.1046,0,2-.8954,2-2V4c0-1.1046-.8954-2-2-2Zm0,26H4V4H28V28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BottlesContainer.propTypes = iconPropTypes;
}
const BottomPanelClose = /*#__PURE__*/React.forwardRef(function BottomPanelClose({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m28,4H4c-1.1045,0-2,.8955-2,2v20c0,1.1045.8955,2,2,2h24c1.1045,0,2-.8955,2-2V6c0-1.1045-.8955-2-2-2Zm0,16v6H4v-6h24Zm0-14v12H4V6h11v6.1699s-3.5898-3.5801-3.5898-3.5801l-1.4102,1.4102,6,6,6-6-1.4102-1.4102-3.5898,3.5801v-6.1699h11Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BottomPanelClose.propTypes = iconPropTypes;
}
const BottomPanelCloseFilled = /*#__PURE__*/React.forwardRef(function BottomPanelCloseFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m28,4H4c-1.1045,0-2,.8955-2,2v20c0,1.1045.8955,2,2,2h24c1.1045,0,2-.8955,2-2V6c0-1.1045-.8955-2-2-2Zm0,2v12H4V6h11v6.1699s-3.5898-3.5801-3.5898-3.5801l-1.4102,1.4102,6,6,6-6-1.4102-1.4102-3.5898,3.5801v-6.1699h11Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BottomPanelCloseFilled.propTypes = iconPropTypes;
}
const BottomPanelOpen = /*#__PURE__*/React.forwardRef(function BottomPanelOpen({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m28,4H4c-1.1045,0-2,.8955-2,2v20c0,1.1045.8955,2,2,2h24c1.1045,0,2-.8955,2-2V6c0-1.1045-.8955-2-2-2Zm0,16v6H4v-6h24Zm0-14v12h-11v-6.1699s3.5898,3.5798,3.5898,3.5798l1.4102-1.4099-6-6-6,6,1.4102,1.4099,3.5898-3.5798v6.1699H4V6h24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BottomPanelOpen.propTypes = iconPropTypes;
}
const BottomPanelOpenFilled = /*#__PURE__*/React.forwardRef(function BottomPanelOpenFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m28,4H4c-1.1045,0-2,.8955-2,2v20c0,1.1045.8955,2,2,2h24c1.1045,0,2-.8955,2-2V6c0-1.1045-.8955-2-2-2Zm0,2v12h-11v-6.1699s3.5898,3.5798,3.5898,3.5798l1.4102-1.4099-6-6-6,6,1.4102,1.4099,3.5898-3.5798v6.1699H4V6h24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BottomPanelOpenFilled.propTypes = iconPropTypes;
}
const Box = /*#__PURE__*/React.forwardRef(function Box({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M20,21H12a2,2,0,0,1-2-2V17a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2v2A2,2,0,0,1,20,21Zm-8-4v2h8V17Z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2,2,0,0,0,2,6v4a2,2,0,0,0,2,2V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V12a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM26,28H6V12H26Zm2-18H4V6H28v4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Box.propTypes = iconPropTypes;
}
const BoxExtraLarge = /*#__PURE__*/React.forwardRef(function BoxExtraLarge({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M26,28H6a2.0021,2.0021,0,0,1-2-2V9H6V26H26V9h2V26A2.0021,2.0021,0,0,1,26,28Z"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M19 21L19 9 17 9 17 23 24 23 24 21 19 21z"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9L14 9 12 15 10 9 8 9 10.752 16 8 23 10 23 12 17 14 23 16 23 13.245 16 16 9z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M4 4H28V6H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BoxExtraLarge.propTypes = iconPropTypes;
}
const BoxLarge = /*#__PURE__*/React.forwardRef(function BoxLarge({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M26,28H6a2.0021,2.0021,0,0,1-2-2V9H6V26H26V9h2V26A2.0021,2.0021,0,0,1,26,28Z"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M14 21L14 9 12 9 12 23 20 23 20 21 14 21z"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M4 4H28V6H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BoxLarge.propTypes = iconPropTypes;
}
const BoxMedium = /*#__PURE__*/React.forwardRef(function BoxMedium({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M26,28H6a2.0021,2.0021,0,0,1-2-2V9H6V26H26V9h2V26A2.0021,2.0021,0,0,1,26,28Z"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9L16.485 14 16 15.977 15.535 14 14 9 12 9 12 23 14 23 14 15 13.842 13.004 14.421 15 16 19.626 17.579 15 18.159 13 18 15 18 23 20 23 20 9 18 9z"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M4 4H28V6H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BoxMedium.propTypes = iconPropTypes;
}
const BoxSmall = /*#__PURE__*/React.forwardRef(function BoxSmall({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M26,28H6a2.0021,2.0021,0,0,1-2-2V9H6V26H26V9h2V26A2.0021,2.0021,0,0,1,26,28Z"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M18,23H12V21h6V17H14a2.002,2.002,0,0,1-2-2V11a2.002,2.002,0,0,1,2-2h6v2H14v4h4a2.002,2.002,0,0,1,2,2v4A2.0023,2.0023,0,0,1,18,23Z"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M4 4H28V6H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BoxSmall.propTypes = iconPropTypes;
}
const BoxPlot = /*#__PURE__*/React.forwardRef(function BoxPlot({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M22,6V4H12V6h4V8H12V20h4v2H12v2H22V22H18V20h4V8H18V6ZM14,18V15h6v3Zm6-5H14V10h6Z"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BoxPlot.propTypes = iconPropTypes;
}
const Branch = /*#__PURE__*/React.forwardRef(function Branch({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m20,6c0,1.8587,1.2795,3.4109,3,3.858v4.142c0,1.6543-1.3457,3-3,3h-8c-1.1299,0-2.1617.391-3,1.0256v-8.1676c1.7203-.4471,3-1.9993,3-3.858,0-2.2061-1.7944-4-4-4s-4,1.7939-4,4c0,1.8587,1.2797,3.4108,3,3.858v12.142s0,.142,0,.142c-1.7203.4473-3,1.9997-3,3.858,0,2.2056,1.7944,4,4,4s4-1.7944,4-4c0-1.8583-1.2797-3.4107-3-3.858v-.142c0-1.6543,1.3457-3,3-3h8c2.7568,0,5-2.2432,5-5v-4.142c1.7205-.4471,3-1.9993,3-3.858,0-2.2061-1.7939-4-4-4s-4,1.7939-4,4Zm-14,0c0-1.1025.897-2,2-2s2,.8975,2,2c0,1.1025-.897,2-2,2s-2-.8975-2-2Zm4,20c0,1.103-.897,2-2,2s-2-.897-2-2,.897-2,2-2,2,.897,2,2ZM26,6c0,1.1025-.8975,2-2,2s-2-.8975-2-2c0-1.1025.8975-2,2-2s2,.8975,2,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Branch.propTypes = iconPropTypes;
}
const BreakingChange = /*#__PURE__*/React.forwardRef(function BreakingChange({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M31,25a6,6,0,1,0-6,6A6.0066,6.0066,0,0,0,31,25Zm-2,0a3.9521,3.9521,0,0,1-.5669,2.019L22.981,21.5669A3.9529,3.9529,0,0,1,25,21,4.0045,4.0045,0,0,1,29,25Zm-8,0a3.9521,3.9521,0,0,1,.5669-2.019l5.4521,5.4521A3.9529,3.9529,0,0,1,25,29,4.0045,4.0045,0,0,1,21,25Z"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M19.59 16L17 18.59 18.42 20 22.42 16 18.42 12 17 13.41 19.59 16z"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M10.41 16L13 13.41 11.58 12 7.58 16 11.58 20 13 18.59 10.41 16z"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M4,9H26v7h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V24a2,2,0,0,0,2,2H16V24H4ZM4,4H26V7H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BreakingChange.propTypes = iconPropTypes;
}
const BrightnessContrast = /*#__PURE__*/React.forwardRef(function BrightnessContrast({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H17V5H15z"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M27 15H30V17H27z"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M15 27H17V30H15z"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15H5V17H2z"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M6.22 5.73H8.219999999999999V8.73H6.22z",
    transform: "rotate(-45 7.227 7.236)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M23.27 6.23H26.27V8.23H23.27z",
    transform: "rotate(-45 24.766 7.232)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M23.77 23.27H25.77V26.27H23.77z",
    transform: "rotate(-45 24.77 24.77)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M5.47 25.13L7.59 23 9 24.42 6.88 26.54 5.47 25.13z"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M16,8a8,8,0,1,0,8,8A8,8,0,0,0,16,8Zm0,14a6,6,0,0,1,0-12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BrightnessContrast.propTypes = iconPropTypes;
}
const BringForward = /*#__PURE__*/React.forwardRef(function BringForward({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M12,15H10V12a2.0023,2.0023,0,0,1,2-2h3v2H12Z"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M15,30H12a2.0023,2.0023,0,0,1-2-2V25h2v3h3Z"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M18 28H22V30H18z"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H25V28h3V25h2v3A2.0023,2.0023,0,0,1,28,30Z"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18H12V22H10z"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M28 18H30V22H28z"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M30,15H28V12H25V10h3a2.0023,2.0023,0,0,1,2,2Z"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M18 10H22V12H18z"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M8,22H4a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,4,2H20a2.0023,2.0023,0,0,1,2,2V8H20V4H4V20H8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BringForward.propTypes = iconPropTypes;
}
const BringToFront = /*#__PURE__*/React.forwardRef(function BringToFront({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H22V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V20a2.0023,2.0023,0,0,0,2,2h6v6a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM4,20,3.9985,4H20v6H12a2,2,0,0,0-2,2v8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BringToFront.propTypes = iconPropTypes;
}
const WatsonHealthBrushFreehand = /*#__PURE__*/React.forwardRef(function WatsonHealthBrushFreehand({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8281,3.1719a4.0941,4.0941,0,0,0-5.6562,0L4.05,22.292A6.9537,6.9537,0,0,0,2,27.2412V30H4.7559a6.9523,6.9523,0,0,0,4.95-2.05L28.8281,8.8286a3.999,3.999,0,0,0,0-5.6567ZM10.91,18.26l2.8286,2.8286L11.6172,23.21,8.7886,20.3818ZM8.2915,26.5356A4.9665,4.9665,0,0,1,4.7559,28H4v-.7588a4.9669,4.9669,0,0,1,1.4644-3.5351l1.91-1.91,2.8286,2.8281ZM27.4141,7.4141,15.1528,19.6748l-2.8286-2.8286,12.2617-12.26a2.0473,2.0473,0,0,1,2.8282,0,1.9995,1.9995,0,0,1,0,2.8282Z"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5,15A3.4994,3.4994,0,0,1,4.0249,9.026l3.5005-3.5a1.5019,1.5019,0,0,0,0-2.121,1.537,1.537,0,0,0-2.1216,0L3.415,5.3936,2,3.98,3.99,1.9915a3.5849,3.5849,0,0,1,4.95,0,3.5039,3.5039,0,0,1,0,4.949L5.439,10.44a1.5019,1.5019,0,0,0,0,2.121,1.5369,1.5369,0,0,0,2.1215,0l4.0249-4.0243L13,9.9507,8.9746,13.975A3.4754,3.4754,0,0,1,6.5,15Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthBrushFreehand.propTypes = iconPropTypes;
}
const WatsonHealthBrushPolygon = /*#__PURE__*/React.forwardRef(function WatsonHealthBrushPolygon({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8281,3.1719a4.0941,4.0941,0,0,0-5.6562,0L4.05,22.292A6.9537,6.9537,0,0,0,2,27.2412V30H4.7559a6.9523,6.9523,0,0,0,4.95-2.05L28.8281,8.8286a3.999,3.999,0,0,0,0-5.6567ZM10.91,18.26l2.8286,2.8286L11.6172,23.21,8.7886,20.3818ZM8.2915,26.5356A4.9665,4.9665,0,0,1,4.7559,28H4v-.7588a4.9669,4.9669,0,0,1,1.4644-3.5351l1.91-1.91,2.8286,2.8281ZM27.4141,7.4141,15.1528,19.6748l-2.8286-2.8286,12.2617-12.26a2.0473,2.0473,0,0,1,2.8282,0,1.9995,1.9995,0,0,1,0,2.8282Z"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M14,2a2.9948,2.9948,0,0,0-2.8157,2H7.8157A2.9925,2.9925,0,1,0,4,7.8154v3.3687a3,3,0,1,0,2,0V7.8159A2.9959,2.9959,0,0,0,7.8157,6h3.3686A2.9947,2.9947,0,1,0,14,2ZM5,15a1,1,0,1,1,1-1A1.0008,1.0008,0,0,1,5,15ZM5,6A1,1,0,1,1,6,5,1.0008,1.0008,0,0,1,5,6Zm9,0a1,1,0,1,1,1-1A1.0008,1.0008,0,0,1,14,6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthBrushPolygon.propTypes = iconPropTypes;
}
const BuildImage = /*#__PURE__*/React.forwardRef(function BuildImage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M30,25v-2h-2.1c-.1-.6-.4-1.2-.7-1.8l1.5-1.5-1.4-1.4-1.5,1.5c-.5-.3-1.1-.6-1.8-.7v-2.1h-2v2.1c-.6.1-1.2.4-1.8.7l-1.5-1.5-1.4,1.4,1.5,1.5c-.3.5-.6,1.1-.7,1.8h-2.1v2h2.1c.1.6.4,1.2.7,1.8l-1.5,1.5,1.4,1.4,1.5-1.5c.5.3,1.1.6,1.8.7v2.1h2v-2.1c.6-.1,1.2-.4,1.8-.7l1.5,1.5,1.4-1.4-1.5-1.5c.3-.5.6-1.1.7-1.8h2.1ZM23,27c-1.7,0-3-1.3-3-3s1.3-3,3-3,3,1.3,3,3-1.3,3-3,3ZM21.4854,7.126L12.4858,2.126c-.3027-.168-.6689-.168-.9717,0L2.5142,7.126c-.3174.1763-.5142.5107-.5142.874v10c0,.3633.1968.6982.5142.874l9,5c.1514.084.3188.126.4858.126.1753,0,.3506-.0459.5073-.1377.3052-.1797.4927-.5078.4927-.8623v-9.4116l7-3.8891v4.3007h2v-6c0-.3633-.1973-.6978-.5146-.874ZM12,4.144l6.9411,3.8561-6.9411,3.8558-6.9409-3.856,6.9409-3.856h0ZM4,17.4111v-7.7117l7,3.8889v7.7124s-7-3.8896-7-3.8896Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BuildImage.propTypes = iconPropTypes;
}
const BuildRun = /*#__PURE__*/React.forwardRef(function BuildRun({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M30,24l-6,6-1.4-1.4,3.6-3.6h-9.2v-2h9.2l-3.6-3.6,1.4-1.4,6,6ZM21.4854,7.126L12.4858,2.126c-.3027-.168-.6689-.168-.9717,0L2.5142,7.126c-.3174.1763-.5142.5107-.5142.874v10c0,.3633.1968.6982.5142.874l9,5c.1514.084.3188.126.4858.126.1753,0,.3506-.0459.5073-.1377.3052-.1797.4927-.5078.4927-.8623v-9.4116l7-3.8891v4.3007h2v-6c0-.3633-.1973-.6978-.5146-.874ZM12,4.144l6.9411,3.8561-6.9411,3.8558-6.9409-3.856,6.9409-3.856h0ZM4,17.4111v-7.7117l7,3.8889v7.7124s-7-3.8896-7-3.8896Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BuildRun.propTypes = iconPropTypes;
}
const BuildTool = /*#__PURE__*/React.forwardRef(function BuildTool({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M28,14h-1V7c0-1.1-0.9-2-2-2h-6v2h6v7h-1c-1.1,0-2,0.9-2,2v9H9.9c-0.4-1.4-1.5-2.5-2.9-2.9V7h6.2l-2.6,2.6L12,11l5-5l-5-5 l-1.4,1.4L13.2,5H7C5.9,5,5,5.9,5,7v15.1c-1.7,0.4-3,2-3,3.9c0,2.2,1.8,4,4,4c1.9,0,3.4-1.3,3.9-3H22v1c0,1.1,0.9,2,2,2h4 c1.1,0,2-0.9,2-2V16C30,14.9,29.1,14,28,14z M6,28c-1.1,0-2-0.9-2-2s0.9-2,2-2c1.1,0,2,0.9,2,2S7.1,28,6,28z M24,28V16h4v12H24z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BuildTool.propTypes = iconPropTypes;
}
const Building = /*#__PURE__*/React.forwardRef(function Building({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H16a2.002,2.002,0,0,0-2,2V14H4a2.002,2.002,0,0,0-2,2V30H30V4A2.0023,2.0023,0,0,0,28,2ZM9,28V21h4v7Zm19,0H15V20a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1v8H4V16H16V4H28Z"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8H20V10H18z"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M24 8H26V10H24z"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14H20V16H18z"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M24 14H26V16H24z"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M18 20H20V22H18z"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M24 20H26V22H24z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Building.propTypes = iconPropTypes;
}
const BuildingInsights_1 = /*#__PURE__*/React.forwardRef(function BuildingInsights_1({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H16a2.002,2.002,0,0,0-2,2V14H4a2.002,2.002,0,0,0-2,2V30H30V4A2.0023,2.0023,0,0,0,28,2ZM9,28V21h4v7Zm19,0H15V20a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1v8H4V16H16V4H28Z"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8H20V10H18z"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M24 8H26V10H24z"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14H20V16H18z"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M24 14H26V16H24z"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M18 20H20V22H18z"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M24 20H26V22H24z"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M9,12H7a5.0059,5.0059,0,0,1,5-5V9A3.0033,3.0033,0,0,0,9,12Z"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M4,12H2A10.0114,10.0114,0,0,1,12,2V4A8.0092,8.0092,0,0,0,4,12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BuildingInsights_1.propTypes = iconPropTypes;
}
const BuildingInsights_2 = /*#__PURE__*/React.forwardRef(function BuildingInsights_2({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H16a2.002,2.002,0,0,0-2,2V14H4a2.002,2.002,0,0,0-2,2V30H30V4A2.0023,2.0023,0,0,0,28,2ZM9,28V21h4v7Zm19,0H15V20a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1v8H4V16H16V4H28Z"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8H20V10H18z"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M24 8H26V10H24z"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14H20V16H18z"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M24 14H26V16H24z"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M18 20H20V22H18z"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M24 20H26V22H24z"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5,12a3.5,3.5,0,0,1,0-7h.627A4.0062,4.0062,0,0,1,10,2h2V4L10,4A2.0023,2.0023,0,0,0,8,6V7H5.5a1.5,1.5,0,0,0,0,3H12v2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BuildingInsights_2.propTypes = iconPropTypes;
}
const BuildingInsights_3 = /*#__PURE__*/React.forwardRef(function BuildingInsights_3({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H16a2.002,2.002,0,0,0-2,2V14H4a2.002,2.002,0,0,0-2,2V30H30V4A2.0023,2.0023,0,0,0,28,2ZM9,28V21h4v7Zm19,0H15V20a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1v8H4V16H16V4H28Z"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8H20V10H18z"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M24 8H26V10H24z"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14H20V16H18z"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M24 14H26V16H24z"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M18 20H20V22H18z"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M24 20H26V22H24z"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10H7V12H2z"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M10 2H12V7H10z"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 3.964H7.5V9.035H5.5z",
    transform: "rotate(-45 6.5 6.5)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BuildingInsights_3.propTypes = iconPropTypes;
}
const Bullhorn = /*#__PURE__*/React.forwardRef(function Bullhorn({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M26,6V8.17L5.64,11.87a2,2,0,0,0-1.64,2v4.34a2,2,0,0,0,1.64,2L8,20.56V24a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V22.74l6,1.09V26h2V6ZM18,24H10V20.93l8,1.45ZM6,18.17V13.83L26,10.2V21.8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Bullhorn.propTypes = iconPropTypes;
}
const Buoy = /*#__PURE__*/React.forwardRef(function Buoy({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M28,22a3.4376,3.4376,0,0,1-3.0513-2.3164,1,1,0,0,0-1.8955-.0049A3.44,3.44,0,0,1,20,22a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,16,19a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,12,22a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,8,19a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,4,22H2v2H4a4.9316,4.9316,0,0,0,4-1.9873,5.5965,5.5965,0,0,0,1,.9912,7,7,0,0,0,14,0,5.5965,5.5965,0,0,0,1-.9912A4.9316,4.9316,0,0,0,28,24h2V22ZM16,28a5.0021,5.0021,0,0,1-4.9075-4.0854A5.2252,5.2252,0,0,0,12,24a4.9316,4.9316,0,0,0,4-1.9873A4.9316,4.9316,0,0,0,20,24a5.2252,5.2252,0,0,0,.9075-.0854A5.0021,5.0021,0,0,1,16,28Z"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M20.07,7.8345A2.0116,2.0116,0,0,0,18.0771,6H17V2H15V6H13.9175a1.9949,1.9949,0,0,0-1.9859,1.7715L10.2805,19h2.021l.7346-5h5.9212l.7351,5h2.021ZM13.33,12l.5877-4,4.167.0625L18.6633,12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Buoy.propTypes = iconPropTypes;
}
const Bus = /*#__PURE__*/React.forwardRef(function Bus({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M27 11H29V15H27z"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M3 11H5V15H3z"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20H22V22H20z"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20H12V22H10z"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M21,4H11A5.0059,5.0059,0,0,0,6,9V23a2.0023,2.0023,0,0,0,2,2v3h2V25H22v3h2V25a2.0027,2.0027,0,0,0,2-2V9A5.0059,5.0059,0,0,0,21,4Zm3,6,.0009,6H8V10ZM11,6H21a2.995,2.995,0,0,1,2.8157,2H8.1843A2.995,2.995,0,0,1,11,6ZM8,23V18H24.0012l.0008,5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Bus.propTypes = iconPropTypes;
}
const BusinessMetrics = /*#__PURE__*/React.forwardRef(function BusinessMetrics({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M22,30c-.3789,0-.7251-.2141-.8945-.5527l-1.7236-3.4473h-3.3818v-2h4c.3789,0,.7252.2141.8946.5529l1.1054,2.211,3.1056-6.2114c.1843-.3685.5393-.5525.8944-.5525s.7102.184.8944.5525l1.7237,3.4475h3.3818v2h-4.0002c-.3787,0-.7249-.214-.8943-.5527l-1.1055-2.2112-3.1055,6.2112c-.1694.3386-.5156.5527-.8945.5527Z"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4141,10l-1.4141-1.4141-4.7147,4.7147c-.3911-.1871-.8236-.3006-1.2853-.3006-1.6543,0-3,1.3457-3,3s1.3457,3,3,3,3-1.3457,3-3c0-.4617-.1135-.8942-.3006-1.2853l4.7147-4.7147ZM16,17c-.5513,0-1-.4487-1-1s.4487-1,1-1,1,.4487,1,1-.4487,1-1,1Z"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M26,16c0-1.666-.4153-3.2354-1.1392-4.6182l-1.4961,1.4961c.4087.9595.6353,2.0146.6353,3.1221h2Z"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M16,8c1.1072,0,2.1624.2266,3.1223.6353l1.4961-1.4961c-1.3831-.7241-2.9521-1.1392-4.6184-1.1392-5.5142,0-10,4.4863-10,10h2c0-4.4111,3.5889-8,8-8Z"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51,24.49c-2.17-2.17-3.51-5.17-3.51-8.49,0-6.63,5.37-12,12-12,6.62,0,11.99,5.38,12,12h2c0-7.73-6.27-14-14-14S2,8.27,2,16c0,3.87,1.57,7.37,4.1,9.9,0,0,1.41-1.41,1.41-1.41Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BusinessMetrics.propTypes = iconPropTypes;
}
const BusinessProcesses = /*#__PURE__*/React.forwardRef(function BusinessProcesses({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "m23.0002,31c-.0095,0-.0188-.0001-.0283-.0004-.4102-.0115-.7715-.2723-.9116-.6578l-3.1365-8.6252-2.0046,4.6774c-.1577.3677-.519.6061-.9192.6061h-4v-2h3.3406l2.7402-6.3939c.1619-.3772.5479-.6166.9473-.6057.4102.0115.7715.2723.9116.6578l3.1365,8.6252,2.0046-4.6774c.1577-.3677.519-.6061.9192-.6061h4v2h-3.3406l-2.7402,6.3939c-.158.3684-.52.6061-.9189.6061Z"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "m9,25h-5v-15h24v9h2v-9c0-1.103-.8975-2-2-2h-6V4c0-1.103-.8975-2-2-2h-8c-1.103,0-2,.897-2,2v4h-6c-1.103,0-2,.897-2,2v15c0,1.1025.897,2,2,2h5v-2ZM12,4h8v4h-8V4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  BusinessProcesses.propTypes = iconPropTypes;
}
const ButtonCentered = /*#__PURE__*/React.forwardRef(function ButtonCentered({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15H23V17H9z"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M28,22H4a2.0021,2.0021,0,0,1-2-2V12a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v8A2.0021,2.0021,0,0,1,28,22ZM4,12v8H28V12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ButtonCentered.propTypes = iconPropTypes;
}
const ButtonFlushLeft = /*#__PURE__*/React.forwardRef(function ButtonFlushLeft({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15H20V17H6z"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M28,22H4c-1.103,0-2-0.897-2-2v-8c0-1.103,0.897-2,2-2h24c1.103,0,2,0.897,2,2v8C30,21.103,29.103,22,28,22z M4,12v8h24v-8 H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ButtonFlushLeft.propTypes = iconPropTypes;
}
const CabinCare = /*#__PURE__*/React.forwardRef(function CabinCare({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3022,2a2.6617,2.6617,0,0,0-1.9079.8059l-.3931.4053-.397-.4053a2.6613,2.6613,0,0,0-3.8158,0,2.7992,2.7992,0,0,0,0,3.8963L25.0012,11,29.21,6.7022a2.7992,2.7992,0,0,0,0-3.8963A2.6613,2.6613,0,0,0,27.3022,2Z"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8218,18H15.083L11.8643,5.9653a4,4,0,0,0-7.7276,2.07L8.5454,24.5168A2,2,0,0,0,10.4775,26H19v2H4v2H19a2,2,0,0,0,2-2V26h3a4.0046,4.0046,0,0,0,3.98-4.4A4.1214,4.1214,0,0,0,23.8218,18ZM24,24H10.4776L6.0686,7.5181A2,2,0,1,1,9.9324,6.4829L13.5466,20H24a2,2,0,0,1,0,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CabinCare.propTypes = iconPropTypes;
}
const CabinCareAlert = /*#__PURE__*/React.forwardRef(function CabinCareAlert({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M24 2H26V9H24z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "3",
    height: "3",
    x: "23.5",
    y: "11",
    rx: "1.5"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8218,18H15.083L11.8643,5.9653a4,4,0,0,0-7.7276,2.07L8.5454,24.5168A2,2,0,0,0,10.4775,26H19v2H4v2H19a2,2,0,0,0,2-2V26h3a4.0046,4.0046,0,0,0,3.98-4.4A4.1215,4.1215,0,0,0,23.8218,18ZM24,24H10.4775L6.0686,7.5181A2,2,0,1,1,9.9324,6.4829L13.5466,20H24a2,2,0,0,1,0,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CabinCareAlert.propTypes = iconPropTypes;
}
const CabinCareAlt = /*#__PURE__*/React.forwardRef(function CabinCareAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M30,25V23H20.7676l-.8-3H27V18H19.4348l-2.469-9.2578-1.9316.5156,3.8017,14.2568A2.0037,2.0037,0,0,0,20.77,25H22v3H10V25h6V23H6.7676l-.8-3H13V18H5.4348L2.9658,8.7422l-1.9316.5156L4.8359,23.5146A2.0037,2.0037,0,0,0,6.77,25H8v3H2v2H30V28H24V25Z"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M27.303,2a2.6613,2.6613,0,0,0-1.9079.8059L25,3.2112l-.3951-.4053a2.6612,2.6612,0,0,0-3.8157,0,2.7991,2.7991,0,0,0,0,3.8963L25,11l4.2108-4.2978a2.7991,2.7991,0,0,0,0-3.8963A2.6613,2.6613,0,0,0,27.303,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CabinCareAlt.propTypes = iconPropTypes;
}
const Cad = /*#__PURE__*/React.forwardRef(function Cad({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M18,9H14a2,2,0,0,0-2,2V23h2V18h4v5h2V11A2,2,0,0,0,18,9Zm-4,7V11h4v5Z"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M26,23H22V9h4a4,4,0,0,1,4,4v6A4,4,0,0,1,26,23Zm-2-2h2a2,2,0,0,0,2-2V13a2,2,0,0,0-2-2H24Z"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M10,23H4a2,2,0,0,1-2-2V11A2,2,0,0,1,4,9h6v2H4V21h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Cad.propTypes = iconPropTypes;
}
const Cafe = /*#__PURE__*/React.forwardRef(function Cafe({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M2 28H30V30H2z"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5,11H8a2.002,2.002,0,0,0-2,2v8a5.0059,5.0059,0,0,0,5,5h8a5.0059,5.0059,0,0,0,5-5V20h.5a4.5,4.5,0,0,0,0-9ZM22,21a3.0033,3.0033,0,0,1-3,3H11a3.0033,3.0033,0,0,1-3-3V13H22Zm2.5-3H24V13h.5a2.5,2.5,0,0,1,0,5Z"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M19,9H17V8.854a1.9883,1.9883,0,0,0-1.1055-1.7886L13.2109,5.7236A3.9788,3.9788,0,0,1,11,2.146V1h2V2.146a1.9892,1.9892,0,0,0,1.1055,1.7886l2.6836,1.3418A3.9792,3.9792,0,0,1,19,8.854Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Cafe.propTypes = iconPropTypes;
}
const Calculation = /*#__PURE__*/React.forwardRef(function Calculation({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8L10 8 10 4 8 4 8 8 4 8 4 10 8 10 8 14 10 14 10 10 14 10 14 8z"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M4 19H14V21H4z"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M4 24H14V26H4z"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8H28V10H18z"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M24.41 22L28 18.41 26.59 17 23 20.59 19.41 17 18 18.41 21.59 22 18 25.59 19.41 27 23 23.41 26.59 27 28 25.59 24.41 22z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Calculation.propTypes = iconPropTypes;
}
const CalculationAlt = /*#__PURE__*/React.forwardRef(function CalculationAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M19 13H25V15H19z"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M13 21L11 21 11 19 9 19 9 21 7 21 7 23 9 23 9 25 11 25 11 23 13 23 13 21z"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9H13V11H7z"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M19 17H25V19H19z"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M27,3H5A2.0023,2.0023,0,0,0,3,5V27a2.0023,2.0023,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V5A2.0023,2.0023,0,0,0,27,3ZM15,5V15H5V5ZM5,17H15V27H5ZM17,27V5H27V27Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CalculationAlt.propTypes = iconPropTypes;
}
const Calculator = /*#__PURE__*/React.forwardRef(function Calculator({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4V28H6V4H26m0-2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V4A2,2,0,0,0,26,2Z"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M9 23H11V25H9z"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M21 23H23V25H21z"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M9 18H11V20H9z"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M21 18H23V20H21z"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13H11V15H9z"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M15 23H17V25H15z"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18H17V20H15z"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M15 13H17V15H15z"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M21 13H23V15H21z"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M9 7H23V10H9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Calculator.propTypes = iconPropTypes;
}
const CalculatorCheck = /*#__PURE__*/React.forwardRef(function CalculatorCheck({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26.59L21.41 24 20 25.41 24 29.41 31 22.41 29.59 21 24 26.59z"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M15 23H17V25H15z"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M9 23H11V25H9z"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M21 18H23V20H21z"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18H17V20H15z"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M9 18H11V20H9z"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M21 13H23V15H21z"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M15 13H17V15H15z"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13H11V15H9z"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M9 7H23V10H9z"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M17,30H6.0046A2.007,2.007,0,0,1,4,27.9951V3.9961A1.9984,1.9984,0,0,1,5.9961,2H26.0037A1.9985,1.9985,0,0,1,28,3.9961V18H26V4H6V28H17Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CalculatorCheck.propTypes = iconPropTypes;
}
const Calendar = /*#__PURE__*/React.forwardRef(function Calendar({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4h-4V2h-2v2h-8V2h-2v2H6C4.9,4,4,4.9,4,6v20c0,1.1,0.9,2,2,2h20c1.1,0,2-0.9,2-2V6C28,4.9,27.1,4,26,4z M26,26H6V12h20 V26z M26,10H6V6h4v2h2V6h8v2h2V6h4V10z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Calendar.propTypes = iconPropTypes;
}
const CalendarAdd = /*#__PURE__*/React.forwardRef(function CalendarAdd({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30 22L24 22 24 16 22 16 22 22 16 22 16 24 22 24 22 30 24 30 24 24 30 24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,6c0-1.1-0.9-2-2-2h-4V2h-2v2h-8V2h-2v2H6C4.9,4,4,4.9,4,6v20c0,1.1,0.9,2,2,2h8v-2H6V6h4v2h2V6h8v2h2V6h4v8h2V6z"
  })))), children);
});
if (process.env.NODE_ENV !== "production") {
  CalendarAdd.propTypes = iconPropTypes;
}

export { ArrowShiftDown, ArrowsHorizontal, ArrowsVertical, Asleep, AsleepFilled, Assembly, AssemblyCluster, AssemblyReference, Asset, AssetConfirm, AssetDigitalTwin, AssetMovement, AssetView, AssignmentActionUsage, Asterisk, Async, At, Attachment, AttributeDefinition, AttributeUsage, AudioConsole, AugmentedReality, Automatic, Autoscaling, Avro, Awake, Badge, BaggageClaim, Bar, Barcode, BareMetalServer, BareMetalServer_01, BareMetalServer_02, Basketball, BastionHost, Bat, BatchJob, BatchJobStep, BatteryCharging, BatteryEmpty, BatteryError, BatteryFull, BatteryHalf, BatteryLow, BatteryQuarter, BatteryWarning, Bee, BeeBat, Beta, Bicycle, Binding_01, Binding_02, Binoculars, BlandAltmanPlot, BlockStorage, BlockStorageAlt, Blockchain, Blog, Bluetooth, BluetoothOff, Book, Bookmark, BookmarkAdd, BookmarkFilled, Boolean, Boot, BootVolume, BootVolumeAlt, BorderBottom, BorderFull, BorderLeft, BorderNone, BorderRight, BorderTop, Bot, BottlesContainer, Bottles_01, Bottles_01Dash, Bottles_02, Bottles_02Dash, BottomPanelClose, BottomPanelCloseFilled, BottomPanelOpen, BottomPanelOpenFilled, Box, BoxExtraLarge, BoxLarge, BoxMedium, BoxPlot, BoxSmall, Branch, BreakingChange, BrightnessContrast, BringForward, BringToFront, BuildImage, BuildRun, BuildTool, Building, BuildingInsights_1, BuildingInsights_2, BuildingInsights_3, Bullhorn, Buoy, Bus, BusinessMetrics, BusinessProcesses, ButtonCentered, ButtonFlushLeft, CabinCare, CabinCareAlert, CabinCareAlt, Cad, Cafe, Calculation, CalculationAlt, Calculator, CalculatorCheck, Calendar, CalendarAdd, QBarrier, QBlochSphere, WatsonHealthAutoScroll, WatsonHealthBrushFreehand, WatsonHealthBrushPolygon };
